/*
 * Copyright 2025 DeviceAtlas Limited. All rights reserved.
 * https://deviceatlas.com 
 */
/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 92:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* jshint strict: false */
var Common = __webpack_require__(782);

var _PERMISSIONS = [
  'accelerometer',
  'accessibility-events',
  'ambient-light-sensor',
  'background-sync',
  'camera',
  'clipboard-read',
  'clipboard-write',
  'geolocation',
  'gyroscope',
  'magnetometer',
  'microphone',
  'midi',
  'notifications',
  'payment-handler',
  'persistent-storage',
  'push',
  'speaker-selection'
];

/**
 * This is collected to help identify firefox private browsing mode.
 * @param webJsProps
 * @private
 */
function detectServiceWorker() {
  return Common.collectData(function () {
    return typeof navigator.serviceWorker !== 'undefined';
  });
}

/**
 * Helps to identify private mode IE.
 * @param webJsProps
 * @private
 */
function collectMsSaveBlob() {
  if (typeof navigator.msSaveBlob !== 'undefined') {
    return Common.collectData(function () {
      return navigator.msSaveBlob;
    });
  }
}

/**
 * Collects the max touch points for a browser
 * @param webJsProps
 * @private
 */
function collectMaxTouchPoints() {
  return Common.collectData(function () {
    return navigator.maxTouchPoints;
  });
}

function isMediaDevicesAvailable() {
  return typeof navigator.mediaDevices !== 'undefined';
}

function isAppleUserAgent(_navigator) {
  
  var ua = getUserAgent(_navigator);

  return !!ua && /iPad|iPhone|iPod|Macintosh/.test(ua);
}

function getHardwareConcurrency(_navigator) {
  return _navigator.hardwareConcurrency;
}

function getPlatform(_navigator) {
  return _navigator.platform;
}

function getUserAgent(_navigator) {
  return (_navigator || {}).userAgent;
}

/**
 * Attempts to collect the language information
 */
var collectLanguage = function () {
  return Common.collectData(function () {
    return navigator.language;
  });
};

/**
 * Attempts to collect the languages information
 */
var collectLanguages = function () {
  return Common.collectData(function () {
    return navigator.languages;
  });
};


/**
 * This is used to help identify chrome incognito mode from version 76 and onwards.
 * @param args - { resolve, reject }
 * @param _apiData - {}
 * @private
 */
function collectWebkitTemporaryStorageQuota(args, _apiData) {

  if (navigator.webkitTemporaryStorage && navigator.webkitTemporaryStorage.queryUsageAndQuota) {
    navigator.webkitTemporaryStorage.queryUsageAndQuota(function (usage, quota) {
        _apiData.webkitTemporaryStorage_used = Common.collectData(function () { return usage; });
        _apiData.webkitTemporaryStorage_quota = Common.collectData(function () { return quota; });

        if (args && args.resolve) {
          args.resolve({
            webkitTemporaryStorage_used: _apiData.webkitTemporaryStorage_used,
            webkitTemporaryStorage_quota: _apiData.webkitTemporaryStorage_quota
          });
        }
      },
      function (error) {

        _apiData.webkitTemporaryStorage_used = Common.collectData(function () { return -1; });
        _apiData.webkitTemporaryStorage_used.e = true;

        _apiData.webkitTemporaryStorage_quota = Common.collectData(function () { return -1; });
        _apiData.webkitTemporaryStorage_quota.e = true;

        if (args && args.resolve) {
          args.resolve({
            webkitTemporaryStorage_used: _apiData.webkitTemporaryStorage_used,
            webkitTemporaryStorage_quota: _apiData.webkitTemporaryStorage_quota
          });
        }
      });
  }
  else if (args && args.resolve) {
    args.resolve();
  }
}

/**
 * Looks at the Permissions API and records the state of each permission.
 *
 * @params args - { resolve, reject }
 */
function detectPermissionsApi(args, _apiData) {

  var isAvailable = navigator && !!navigator.permissions;
  var isQueryPresent = isAvailable && !!navigator.permissions.query && typeof navigator.permissions.query === 'function';

  _apiData.permissions = {
    available: isAvailable,
    query: isQueryPresent,
    inComplete: [],
    completed: {},
    failed: 0
  };

  if (!isQueryPresent) {
    if (args && args.resolve) {
      args.resolve(_apiData.permissions);
    }
    return _apiData.permissions;
  }

  var recordFailedAttempt = function (error, _args, _apiData) {
    _apiData.permissions.failed++;

    if (_args && _args.resolve) {
      _args.resolve();
    }
  };

  var onSuccess = function (result, _args, _apiData) {
    if (!result || !result.name || !result.state) {
      return recordFailedAttempt(result, _args, _apiData);
    }
    var name = result.name;
    var index = _apiData.permissions.inComplete.indexOf(name);
    _apiData.permissions.inComplete.splice(index, 1);
    _apiData.permissions.completed[name] = { state: result.state, onChange: !!result.onchange };

    if ('notifications' === name) {
      try {
        _apiData.permissions.completed[name].permission = Notification.permission;
      }
      catch (e) {
        recordFailedAttempt(e, null, _apiData);
      }
    }

    if (_args && _args.resolve) {
      _args.resolve(_apiData.permissions.completed[name]);
    }
  };

  var permissionsPromise = function (permission) {
    _apiData.permissions.inComplete.push(permission);

    return new Promise(function (resolve, reject) {
      navigator.permissions.query({ name: permission })
        .then(function(result) {
          onSuccess(result, { resolve: resolve }, _apiData);
        })
        .catch(function(result) {
          recordFailedAttempt(result, { resolve: resolve }, _apiData);
        });
    });
  };

  var promises = [];
  for (var i = 0; i < _PERMISSIONS.length; i++) {
    promises.push(permissionsPromise(_PERMISSIONS[i]));
  }

  Promise.all(promises).then(function () {
    if (args && args.resolve) {
      args.resolve(_apiData.permissions);
    }
  });

  return _apiData.permissions;
}

/**
 * Attempts to collect the battery manager information
 */
function collectBatteryManager(args, _apiData) {

  var isPresent = !!navigator.getBattery && typeof navigator.getBattery === 'function';

  _apiData.getBattery = { available: isPresent };

  if (!_apiData.getBattery.available) {
    if (args && args.resolve) {
      args.resolve(_apiData.getBattery);
    }
    return _apiData.getBattery;
  }

  var onSuccess = function (battery) {
    _apiData.getBattery.charging = battery.charging;
    _apiData.getBattery.level = battery.level;
    _apiData.getBattery.chargingTime = battery.chargingTime;
    _apiData.getBattery.dischargingTime = battery.dischargingTime;

    if (args && args.resolve) {
      args.resolve(_apiData.getBattery);
    }
  };

  var onError = function () {
    _apiData.getBattery.failed = true;

    if (args && args.resolve) {
      args.resolve(_apiData.getBattery);
    }
  };

  navigator.getBattery()
    .then(onSuccess)
    .catch(onError);

  return _apiData.getBattery;
}

/**
 * Collects the navigator.mediaDevices in the browser
 * @param args
 * @param _apiData
 * @private
 */
function collectMediaDevices(args, _apiData) {

  if (!isMediaDevicesAvailable()) {

    if (args && args.resolve) {
      args.resolve();
    }
    return;
  }

  // Handling how the media devices are obtained. Forcing a wait on promise before sending to API
  navigator.mediaDevices.enumerateDevices()
    .then(function(devices) {
      var text = '';

      for (var _i = 0; _i < devices.length; _i++) {
        if (devices[_i]) {
          text = text + devices[_i].kind + ': ' + devices[_i].label + ' id = ' + devices[_i].deviceId + '\n';
        }
      }
      _apiData['navigator.mediaDevices'] = text;

      if (args && args.resolve) {
        args.resolve(text);
      }
    })
    .catch(function(err) {
      if (args && args.resolve) {
        args.resolve();
      }
    });
}


var NavigatorCollector = {
  detectServiceWorker: detectServiceWorker,
  collectMsSaveBlob: collectMsSaveBlob,
  collectMaxTouchPoints: collectMaxTouchPoints,
  isMediaDevicesAvailable: isMediaDevicesAvailable,
  isAppleUserAgent: isAppleUserAgent,
  getHardwareConcurrency: getHardwareConcurrency,
  getPlatform: getPlatform,
  getUserAgent: getUserAgent,
  collectLanguage: collectLanguage,
  collectLanguages: collectLanguages,

  collectWebkitTemporaryStorageQuota: collectWebkitTemporaryStorageQuota,
  detectPermissionsApi: detectPermissionsApi,
  collectBatteryManager: collectBatteryManager,
  collectMediaDevices: collectMediaDevices,

  collect: function (webJsProps) {

    if (!webJsProps) {
      return;
    }

    var dataCollectors = [
      { key: 'navigator_language',       collection: collectLanguage },
      { key: 'navigator_languages',      collection: collectLanguages },
      { key: 'navigator_maxTouchPoints', collection: collectMaxTouchPoints },
      { key: 'serviceWorker',            collection: detectServiceWorker },
      { key: 'msSaveBlob',               collection: collectMsSaveBlob, conditions: function (value) { return typeof value !== 'undefined'; } }
    ];

    for (var i = 0; i < dataCollectors.length; i++) {
      var collector = dataCollectors[i];
      var allowCollect = collector.conditions || function () { return true; };
      var value = collector.collection(webJsProps);

      if (allowCollect(value)) {
        webJsProps[collector.key] = value;
      }
    }
  },
  getCollectionsForAsync: function () {
    return [
      { name: 'navigator_mediaDevices',           collection: collectMediaDevices },
      { name: 'navigator_getBattery',             collection: collectBatteryManager },
      { name: 'navigator_permissions',            collection: detectPermissionsApi },
      { name: 'navigator_webkitTemporaryStorage', collection: collectWebkitTemporaryStorageQuota }
    ];
  }
};

module.exports = NavigatorCollector;


/***/ }),

/***/ 565:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* jshint strict: false */

var Common = __webpack_require__(782);


function getStorageGetDirectory() {
  return navigator && navigator.storage && navigator.storage.getDirectory;
}
/**
 * Collect Storage Properties
 * @param webJsProps
 * @private
 */
function detectStorageGetDirectory() {
  return Common.collectData(function () {
    if (typeof getStorageGetDirectory() !== 'undefined') {
      return true;
    }
  });
}

/**
 * Helper Method for collecting data for navigator.storage.estimate
 * @param estimate
 * @param property
 * @returns {{a: boolean, e: boolean}}
 */
function _collectNavigatorStorageEstimateProperty(estimate, property) {
  return Common.collectData(function () {

    if (estimate && typeof estimate[property] !== 'undefined') {
      return estimate[property];
    }

  });
}

/**
 * Method for collecting navigator.storage.estimate() data:
 * - quota
 * - usage
 * - usageDetails
 * @param args
 * @param _apiData
 */
function collectNavigatorStorageEstimate(args, _apiData) {

    if (navigator && navigator.storage && navigator.storage.estimate) {
      navigator.storage.estimate()
        .then(function (estimate) {
          _apiData.navigator_storage_quota = _collectNavigatorStorageEstimateProperty(estimate, 'quota');
          _apiData.navigator_storage_usage = _collectNavigatorStorageEstimateProperty(estimate, 'usage');
          _apiData.navigator_storage_usageDetails = _collectNavigatorStorageEstimateProperty(estimate, 'usageDetails');

          if (args && args.resolve) {
            args.resolve({
              navigator_storage_quota: _apiData.navigator_storage_quota,
              navigator_storage_usage: _apiData.navigator_storage_usage,
              navigator_storage_usageDetails: _apiData.navigator_storage_usageDetails
            });
          }
        })
        .catch(function() {
          if (args && args.resolve) {
            args.resolve();
          }
        });
    }
    else if (args && args.resolve) {
      args.resolve();
    }
}

/**
 * Method that detects whether or not it's possible to access `navigator.storage.getDirectory`
 * In Firefox private mode, it throws an error.
 * @param args
 * @param _apiData
 */
function canAccessStorageGetDirectory(args, _apiData) {

  if (!!getStorageGetDirectory()) {

    navigator.storage.getDirectory().then(function (data) {
        _apiData.navigator_storage_getDirectory_access = Common.collectData(function () {
          return data.kind + '_' + data.name;
        });
      })
      .catch(function (error) {
        _apiData.navigator_storage_getDirectory_access = Common.collectData(function () {
          return error.message;
        });
      })
      .finally(function () {
        if (args && args.resolve) {
          args.resolve(_apiData.navigator_storage_getDirectory_access);
        }
      });
  }
  else if (args && args.resolve) {
    args.resolve();
  }
}

var NavigatorStorageCollector = {
  collectNavigatorStorageEstimate: collectNavigatorStorageEstimate,
  collectNavigatorStorageEstimateProperty: _collectNavigatorStorageEstimateProperty,
  canAccessStorageGetDirectory: canAccessStorageGetDirectory,
  detectStorageGetDirectory: detectStorageGetDirectory,

  collect: function (webJsProps) {
    var dataCollectors = [
      { key: 'navigator_storage_getDirectory', collection: detectStorageGetDirectory }
    ];

    for (var i = 0; i < dataCollectors.length; i++) {
      var collector = dataCollectors[i];
      var allowCollect = collector.conditions || function () { return true; };
      var value = collector.collection(webJsProps);

      if (allowCollect(value)) {
        webJsProps[collector.key] = value;
      }
    }
  },
  getCollectionsForAsync: function () {
    return [
      { name: 'navigator_storage',                     collection: collectNavigatorStorageEstimate },
      { name: 'navigator_storage_getDirectory_access', collection: canAccessStorageGetDirectory    }
   ];
  }
};

module.exports = NavigatorStorageCollector;


/***/ }),

/***/ 782:
/***/ (function(module) {

/* jshint strict: false */

var _createCommonObject = function () {
  return { a: false, e: false };
};

/**
 * Common Format for a lot of newer properties
 * @param dataFunction
 * @param args
 * @returns {{a: boolean, e: boolean}}
 * @private
 */
var _collectData = function (dataFunction, args) {
  var data = _createCommonObject();

  try {
    var result = dataFunction(args);
    if (typeof result !== 'undefined') {
      data.a = true;
      data.v = result;
    }
  }
  catch (e) {
    data.e = true;
  }

  return data;
};


var Common = {
  createCommonObject: _createCommonObject,
  collectData: _collectData
};

module.exports =  Common;


/***/ }),

/***/ 914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* jshint strict: false */

var Common = __webpack_require__(782);
var NavigatorCollector = __webpack_require__(92);
var NavigatorStorageCollector = __webpack_require__(565);

module.exports = (function(libraryArgs, undefined) {

  var window = libraryArgs.window;
  var document = libraryArgs.document;
  var navigator = libraryArgs.navigator;

  var _globalOptions = {};

  var version = "1.0.32";

  var devicePropertiesAsString = "";
  var _DeviceValidation = {};
  var ApiClient = null;
  var DataCollector = null;
  var _DeviceAtlasCollector = null;
  var propertiesLoadComplete = false;
  var getPropertiesTimeoutInitialized = false;

  var isAppleDevice;
  var timeoutInitialized = false;
  var WAIT_ATTEMPTS = {
    SERVER_TO_SERVER: 0,
    AUDIO_REF: 0
  };
  var MAX_WAIT_ATTEMPTS = 10;
  var DEFAULT_TIME_TO_WAIT = 30;
  var loading = false;

  var STRING_SEPARATOR = '__';
  var VARIANT_PREFIX_BASE = 'DV-VARIANT';
  var VARIANT_PREFIX = VARIANT_PREFIX_BASE + '-' + version + STRING_SEPARATOR;
  var VARIANT_ID = '';

  var MESSAGE_TYPES = {
    DA_MESSAGE: 'DA_MESSAGE',
    WAIT_AUDIO_REF: 'WAIT_AUDIO_REF',
    ON_LOAD: 'ON_LOAD'
  };

  var STORAGE_TYPE = {
    COOKIE: 'cookie',
    LOCAL_STORAGE: 'local-storage',
    NONE: 'none'
  };

  var DEFAULT_OPTIONS = {
    THIRTY_MINUTES_IN_MILLIS: 30 * 60 * 1000, // 30 Minutes
    TWENTY_FOUR_HOURS_IN_MILLIS: 24 * 60 * 60 * 1000, // 24 Hours
    CACHE_KEY: 'DV',
    CACHE_VALUE: '1'
  };

  var _PERMISSIONS = [
    'accelerometer',
    'accessibility-events',
    'ambient-light-sensor',
    'background-sync',
    'camera',
    'clipboard-read',
    'clipboard-write',
    'geolocation',
    'gyroscope',
    'magnetometer',
    'microphone',
    'midi',
    'notifications',
    'payment-handler',
    'persistent-storage',
    'push',
    'speaker-selection'
  ];

  var apiData = null;

  var currentUrl;
  var attempt = 0;
  // noinspection JSMismatchedCollectionQueryUpdate
  var prevErrors = [];
  var missingProperties = {};

  var _cache = {};

  var HttpStatus = {
    OK: 200,
    ACCEPTED: 202,
    BAD_REQUEST: 400,
    CONFLICT: 409,
    GONE: 410,
    UNPROCESSABLE_ENTITY: 422,
    TOO_MANY_REQUEST: 429
  };

  var HttpRequestState = {
    UNSENT: 0,
    OPENED: 1,
    HEADERS_RECEIVED: 2,
    LOADING: 3,
    DONE: 4
  };

  var PROMISE_TIMEOUT = 800;

  var XMLHttpFactories = [
    function () { return new XMLHttpRequest();                    },
    function () { return new ActiveXObject('Msxml3.XMLHTTP');     },
    function () { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); },
    function () { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); },
    function () { return new ActiveXObject('Msxml2.XMLHTTP');     },
    function () { return new ActiveXObject('Microsoft.XMLHTTP');  }
  ];

  var _overriddenConfig = null;
  var _legacyMode = false;
  var _scriptAttributes = {};
  var _initialised = 0;
  var _metrics = {};

  /**
   * Method that looks at if some properties are present or if we have waited long enough for some properties
   *
   * @param task - key inside the WAIT_ATTEMPTS object.
   *
   * @returns {boolean}
   */
  var haveCriticalPropertiesLoaded = function (task) {
    return hasExceededAttempts(task) || _hasAudioRef();
  };


  /**
   * Checks if a specified task has exceeded the number of attempts to see if the value is present
   *
   * @param task
   * @returns {boolean}
   */
  var hasExceededAttempts = function (task) {
    return WAIT_ATTEMPTS[task] === undefined || WAIT_ATTEMPTS[task] === null || WAIT_ATTEMPTS[task] >= MAX_WAIT_ATTEMPTS;
  };

  /**
   * Returns whether library has been configured for serverToServer
   * @param options
   * @returns {*|{}|boolean}
   */
  var isServerToServer = function (options) {

    var dvOptions = options || _globalOptions || {};

    return (dvOptions && (dvOptions.s2s || dvOptions.serverToServer)) || undefined;
  };

  var isValidLicenceKey = function (options) {

    if (_isCustomUrlMode()) {
      return true;
    }

    if (!_validateLicence(options.licence, options)) {
      return false;
    }

    return options && options.licence && options.licence !== '<LICENCE_KEY>';
  };

  var getPayloadData = function (callback, payloadBuilder, _args) {
    var payloadData = payloadBuilder(_args);

    delete payloadData.info.dataCollectorKey;

    var configs = {
      onSuccess: !!callback,
      method: _args && _args.method,
      serverToServer: true
    };

    payloadData.info.serverToServer = true;

    _appendRequestConfigs(payloadData, configs);

    _completeSession();

    // call it if a callback function was provided and return else return payload
    if (callback != null && typeof callback === 'function') {
      callback(payloadData);
      return;
    }
    return payloadData;
  };

  /**
   * Adds an error element to the local buffer
   */
  var addError = function(errorObj) {
    prevErrors.push(errorObj);
  };

  var flushErrors = function() {
    prevErrors = [];
    loading = false;
    flushMissingProperties();
    resetAttempts();
  };

  var flushMissingProperties = function() {
    missingProperties = {};
  };

  var resetAttempts = function() {
    WAIT_ATTEMPTS = { SERVER_TO_SERVER: 0, AUDIO_REF: 0 };
  };

  var createXMLHTTPObject = function() {
    var xmlHTTP = false;
    for (var i = 0; i < XMLHttpFactories.length; i++) {
      try {
        xmlHTTP = XMLHttpFactories[i]();
      }
      catch (e) {
        continue;
      }
      break;
    }

    return xmlHTTP;
  };

  var getApiUrls = function () {
    var apiUrls = (_globalOptions && _globalOptions.urls) || [];

    if (apiUrls.length > 0) {
      return apiUrls;
    }
    return _getDefaultOptions().urls;
  };

  var httpStatusToIgnored = function(status) {

    if (typeof status === 'undefined') {
      return false;
    }

    // status not to retry on
    return [HttpStatus.CONFLICT, HttpStatus.GONE, HttpStatus.TOO_MANY_REQUEST, HttpStatus.UNPROCESSABLE_ENTITY].indexOf(status) > -1;
  };


  /**
   * deprecated
   *
   * Method for making the API request to the DeviceAssure API.
   *
   * @param licence
   * @param onSuccess
   * @param onError
   * @param suppliedPayload
   * @param currentUrl
   * @param resolve
   * @param reject
   * @param urls
   */
  var doRequest = function(licence, onSuccess, onError, suppliedPayload, currentUrl, resolve, reject, urls) {
    return _doRequest({
      licence: licence,
      onSuccess: onSuccess,
      onError: onError,
      suppliedPayload: suppliedPayload,
      currentUrl: currentUrl,
      resolve: resolve,
      reject: reject,
      urls: urls
    });
  };

  /***
   * Method for making the API request to the DeviceAssure API. It uses an object to pass in the arguments.
   *
   * @param args.licence
   * @param args.onSuccess
   * @param args.onError
   * @param args.suppliedPayload
   * @param args.currentUrl
   * @param args.resolve
   * @param args.reject
   * @param args.urls
   * @param args.method
   */
  var _doRequest = function(args) {
    var licence = args.licence;
    var onSuccess = args.onSuccess;
    var onError = args.onError;
    var suppliedPayload = args.suppliedPayload;
    var currentUrl = args.currentUrl;
    var resolve = args.resolve;
    var reject = args.reject;
    var urls = args.urls;
    var method = args && args.method;

    var xhr = createXMLHTTPObject();

    if (!xhr) {
      // This browser does not support Ajax
      return;
    }
    loading = true;

    var _urls = urls || getApiUrls();

    currentUrl = !!currentUrl ? currentUrl : _urls[attempt];

    xhr.open('POST', currentUrl, true);
    xhr.setRequestHeader('Content-Type', 'application/json');

    xhr.onerror = function(e) {
      addError({hostUrl: currentUrl, httpStatus: 'N/A'});
      var response = {
        status: xhr.status,
        response: xhr.response
      };
      failover(licence, onSuccess, onError, suppliedPayload, response, reject, urls);
    };

    xhr.onreadystatechange = function () {

      if (xhr.readyState !== HttpRequestState.DONE) {
        return;
      }

      var response = {
        status: xhr.status,
        response: xhr.response
      };

      // on success
      if (xhr.status === HttpStatus.OK || xhr.status === HttpStatus.ACCEPTED) {
        _setTTL(response);

        attempt = 0;
        flushErrors();
        onSuccess(response);
        _completeSession();

        if (resolve) {
          return resolve(response);
        }
        return response;
      }

      if (httpStatusToIgnored(xhr.status)) {

        attempt = 0;
        flushErrors();
        onError(response);
        _completeSession();

        if (reject) {
          return reject(response);
        }
        return response;
      }

      // on error
      if (xhr.status >= HttpStatus.BAD_REQUEST) {
        addError({hostUrl: currentUrl, httpStatus: xhr.status});
        return failover(licence, onSuccess, onError, payload, response, reject, urls);
      }
    };
    var payload = suppliedPayload;

    if (!payload) {
      payload = buildPayload({ licence: licence });
    }

    var configs = {
      onSuccess: onSuccess,
      onError: onError,
      method: method
    };

    if (_globalOptions) {
      configs.storageType = _globalOptions.sType;
      configs.storageExpiry = _globalOptions.sExpiry;
    }

    if (_overriddenConfig && _overriddenConfig.urls) {
      configs.urls = _urls;
    }

    _appendRequestConfigs(payload, configs);

    var dvLibraryType = 'web';

    if (isImeiEnabled(args) && !!payload.data.telephony.imei) {
      dvLibraryType = dvLibraryType + '-and-imei';
    }
    xhr.setRequestHeader('library-type', dvLibraryType);

    var jsonPayload = JSON.stringify(payload);
    xhr.send(jsonPayload);
  };

  /**
   * Builds the telephony block of the payload.
   *
   * When an imei arg is passed in, then it will populate these fields too.
   *
   * The TAC is the first 8 digits of the IMEI.
   *
   * @param imei
   * @returns {{tac: null, imei: null }}
   * @private
   */
  var _buildTelephony = function(imei) {
    var telephony = {};

    var imeiValue = (imei && imei.replace(/\s/g, '')) || null;

    if (imeiValue) {
      telephony.imei = imeiValue;
      telephony.tac = imeiValue.length > 7 ? imeiValue.substring(0, 8) : imeiValue;
    }

    return telephony;
  };

  /**
   * Adds in the IMEI to the payload passed in or returns the new payload block
   * @param args - { licence, imei, payload }
   * @returns {{data: {memory: {}, sensors: [], build: {brand: *}, usb: {}, web: {webview: {jsProps: {}}, webviewUserAgent, systemUserAgent}, telephony: {isVoiceCapable: *, tac: null, imei: null, phoneCount: number}, display: {xDpi: *, heightPixels: number, yDpi: *, widthPixels: number}, cpu: {numCores: *, availableProcessors: *}, storage: {}, camera: [], gpu: {}}, info: {date: string, dataCollectorKey: *, serverToServer: boolean, source: string, version: string}}|*}
   * @private
   */
  var _buildIMEIPayload = function(args) {

    var licence = args && args.licence;
    var imei = args && args.imei;
    var payload = args && args.payload;

    if (!payload || Object.keys(payload).length === 0) {
      return buildPayload({ licence: licence, imei: imei });
    }

    if (!imei || imei.length < 1) {
      return payload;
    }

    var telephony = _buildTelephony(imei);

    if (payload && payload.data && !payload.data.telephony) {
      payload.data.telephony = telephony;
    }
    else if (payload && payload.data && payload.data.telephony) {
      payload.data.telephony.imei = telephony.imei;

      if (telephony.tac) {
        payload.data.telephony.tac = telephony.tac;
      }
    } else if (!payload.data) {
      payload.data = {
        telephony: telephony
      };
    }

    return payload;
  };

  /**
   * Returns whether the imei check is turned on or not.
   * @param params
   * @returns {boolean}
   */
  var isImeiEnabled = function(params) {

    var options = {};
    if (_legacyMode && !!_globalOptions) {
      options = _globalOptions;
    }
    else if (params) {
      options = params;
    }
    return !!options.imei || undefined;
  };

  /**
   * Validate the tag key and value
   * @param key
   * @param value
   */
  var validateTag = function (key, value) {

    var rangeCheck = function (field, _value, min, max, extra) {
      if (_value && _value.length < min || _value.length > max) {
        var msg = 'Tag ' + field + ' must be between ' + min + ' and ' + max + ' characters';
        if (extra) {
          msg = msg + ', ' + extra;
        }
        throw new Error(msg);
      }
    };

    var typeCheck = function (field, _value, expected, extra) {
      if (typeof _value !== expected) {
        var msg = 'Tag ' + field + ' must be a ' + expected;
        if (extra) {
          msg = msg + ', ' + extra;
        }
        throw new Error(msg);
      }
    };

    var isAllSpaces = function (field, _value, extra) {
      var sanitized = _trim(_value, ' ');
      if (sanitized.length <= 0) {
        var msg = 'Tag ' + field + ' must not be empty';
        if (extra) {
          msg = msg + ', ' + extra;
        }
        throw new Error(msg);
      }
    };

    var containsSeparator = function (field, _value, extra) {
      if (_value.indexOf(STRING_SEPARATOR) > -1) {
        var msg = 'Tag ' + field + ' must not contain the separator "' + STRING_SEPARATOR + '"';
        if (extra) {
          msg = msg + ', ' + extra;
        }
        throw new Error(msg);
      }
    };

    var tagRules = [
      { id: 'tag-key-type',    validation: function() { typeCheck('key', key, 'string', 'for key: "' + key + '"'); } },
      { id: 'tag-key-length',  validation: function() { rangeCheck('key', key, 1, 64, 'for key: "' + key + '"'); } },
      { id: 'tag-key-spaces',  validation: function() { isAllSpaces('key', key, 'for key: "' + key + '"'); } },
      { id: 'tag-key-separator',  validation: function() { containsSeparator('key', key, 'for key: "' + key + '"'); } },

      { id: 'tag-value-type',   validation: function() { typeCheck('value', value, 'string', 'for key: "' + key + '"'); } },
      { id: 'tag-value-length', validation: function() { rangeCheck('value', value, 1, 128, 'for key: "' + key + '"'); } },
      { id: 'tag-value-spaces', validation: function() { isAllSpaces('value', value, 'for key: "' + key + '"'); } },
    ];

    for (var i = 0; i < tagRules.length; i++) {
      tagRules[i].validation();
    }
  };

  /**
   * Converts a list of objects to a single object, in the format of [{ key: value }, {key1: value2}], becomes
   * { key: value, key1: value2 }
   *
   *
   * @param tags
   * @returns {null}
   */
  var validateTags = function(tags) {

    if (!tags || tags.length <= 0) {
      return null;
    }

    var _tags = null;
    for (var i = 0; i < tags.length; i++) {

      var tag = tags[i];

      if (tag) {
        if (!tag.hasOwnProperty('key')) {
          throw new Error('Missing tag property "key"');
        }

        if (!tag.hasOwnProperty('value')) {
          throw new Error('Missing tag property "value"');
        }


        if (tag.hasOwnProperty('key') && tag.hasOwnProperty('value')) {
          validateTag(tag.key, tag.value);

          if (!_tags) {
            _tags = {};
          }
          var _key = _trim(tag.key, ' ');
          _tags[i + STRING_SEPARATOR + _key] = _trim(tag.value, ' ');
        }
      }
      else {
        throw new Error('Missing tag arguments');
      }
    }

    if (!_tags || Object.keys(_tags).length <= 0) {
      throw new Error('Invalid tag arguments');
    }

    return _tags;
  };

  /**
   * Builds the payload for the API request
   * @param args - { licence, imei }
   * @returns {{data: {memory: {}, sensors: [], build: {brand: *}, usb: {}, web: {webview: {jsProps: {}}, webviewUserAgent, systemUserAgent}, telephony: {isVoiceCapable: *, tac: null, imei: null, phoneCount: number}, display: {xDpi: *, heightPixels: number, yDpi: *, widthPixels: number}, cpu: {numCores: *, availableProcessors: *}, storage: {}, camera: [], gpu: {}}, info: {date: string, dataCollectorKey: *, serverToServer: boolean, source: string, version: string}}}
   */
  var buildPayload = function(args) {

    var licence = args && args.licence;
    var imei = args && args.imei;

    _metrics.payload = Date.now();

    var variants = _buildVariants();

    var userAgent = NavigatorCollector.getUserAgent(navigator);
    var payload = {
      info: {
        version: version,
        date: now(),
        source: 'Device Validation Web Client',
        serverToServer: false,

        variants: variants.ids,
        variantCount: variants.count,
      },
      data: {
        build: {
          brand: NavigatorCollector.getPlatform(navigator),
        },
        cpu: {
          availableProcessors: NavigatorCollector.getHardwareConcurrency(navigator),
          numCores: NavigatorCollector.getHardwareConcurrency(navigator)
        },
        display: {
          widthPixels:  window.screen.width,
          heightPixels: window.screen.height,
          xDpi: window.screen.deviceXDPI,
          yDpi: window.screen.deviceYDPI,
        },
        telephony: _buildTelephony(imei),
        web: {
          systemUserAgent: userAgent,
          webviewUserAgent: userAgent,
          webview: {
            jsProps: {},
            contexts: {
              o: null
            }
          }
        },
        gpu: {}
      }
    };

    if (_globalOptions && !!_globalOptions.tags) {
      if (!payload.meta) {
        payload.meta = {};
      }
      payload.meta.tags = _globalOptions.tags;
    }

    if (_legacyMode) {
      payload.info.legacy = true;
    }

    // Add errors carried over to the payload
    payload.errors = prevErrors || [];

    // for (var key in (missingProperties || {})) {
    //     var attempts = missingProperties[key];
    //
    //     if (attempts && attempts.length > 0) {
    //         payload.errors.push({ missingProperty: key, attempts: attempts });
    //     }
    // }

    _collectGpuProperties(payload.data.gpu);
    // use the concatenated String form of properties from the DeviceAtlas client-side
    // component until such time DeviceAtlas adds an easier way to get all the properties.

    var deviceAtlasProperties = getDeviceAtlasProperties();
    payload.data.web.webview.jsProps = getAdditionalWebProperties(deviceAtlasProperties);
    payload.data.web.webview.clientSide = getDevicePropsAsString();
    payload.data.web.webview.contexts.o = _collectOverrides();

    if (!_isCustomUrlMode()) {
      payload.info.dataCollectorKey = licence;
    }

    __flushCache();

    if (_metrics && _metrics.init && _metrics.payload) {
      payload.info.ttr = _metrics.payload - _metrics.init;
    }

    if (_metrics && _metrics.load && _metrics.payload) {
      payload.info.ttl = _metrics.payload - _metrics.load;
    }

    if (_metrics && _metrics.asyncFinished) {
      payload.info.ttca = _metrics.asyncFinished - _metrics.asyncStart;
    }

    return payload;
  };

  var failover = function(licence, onSuccess, onError, payload, response, reject, urls, method) {
    if (isLastRetryAttempt(urls)) {
      attempt = 0;
      flushErrors();
      onError(response);
      _completeSession();
      return reject ? reject(response) : response;
    }

    attempt++;
    var url = (urls || getApiUrls())[attempt];

    var _args = {
      licence: licence,
      onSuccess: onSuccess,
      onError: onError,
      payload: payload,
      currentUrl: url,
      overrideLoading: true,
      urls: urls,
      method: method
    };

    if (isPromiseSupported()) {
      return getApiClient().validateDevice(_args).then(function onFulfilled() {}, reject);
    }

    getApiClient().validateDevice(_args);
  };

  /**
   * Collects the GPU properties from the browser.
   *
   * @param payload
   * @returns {{}|*}
   * @private
   */
  var _collectGpuProperties = function (payload) {
    var canvas = document.createElement('canvas');
    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

    var result = payload || {};
    if (gl) {
      if (gl.getParameter) {
        if (gl.VERSION && gl.getParameter(gl.VERSION)) {
          result.webGlVersion = gl.getParameter(gl.VERSION);
        }
        if (gl.VENDOR && gl.getParameter(gl.VENDOR)) {
          result.webGlVendor = gl.getParameter(gl.VENDOR);
        }
        if (gl.RENDERER && gl.getParameter(gl.RENDERER)) {
          result.webGlRenderer = gl.getParameter(gl.RENDERER);
        }
      }

      var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
      if (debugInfo) {
        result.vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
        result.renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
      }
    }
    return result;
  };

  var isLastRetryAttempt = function(urls) {
    var attemptURLS = urls || getApiUrls();
    return attempt === attemptURLS.length - 1;
  };

  var isPromiseSupported = function() {
    try {
      var _p = Promise || window.Promise;
      if (_p) {
        return typeof _p !== 'undefined';
      }
    }
    catch(e) {
      // ignore the error
    }
    return false;
  };

  var now = function() {
    var today = new Date();
    var pad = function (n) { return n < 10 ? '0' + n : n; };
    return today.getFullYear() + '-' +
      pad(today.getMonth() + 1) + '-' +
      pad(today.getDate()) + 'T' +
      pad(today.getHours()) + ':' +
      pad(today.getMinutes()) + ':' +
      pad(today.getSeconds());
  };
  /**
   * Returns the storage type for the configuration for Device Validation.
   *
   * Should return whatever is configured, or the default value:
   * - cookie
   * - local-storage
   *
   * @returns {string}
   * @private
   */
  var _getCurrentStorageType = function (overrideOptions) {

    var _options = {};

    if (_globalOptions && Object.keys(_globalOptions).length > 0) {
      _options = _globalOptions;
    }
    else if (overrideOptions) {

      var options = overrideOptions;

      if (typeof overrideOptions === 'string') {
        options = JSON.parse(overrideOptions);
      }

      if (Object.keys(options).length > 0) {
        _options = options;
      }
    }

    return _getStorageType(_options);
  };

  /**
   * Returns the storage type from the options passed in.
   * @param options
   * @returns {*|string}
   * @private
   */
  var _getStorageType = function (options) {

    var _options = options || {};

    var storage = _trim((_options.sType || _options.storageType) || null, ' ');

    if ([STORAGE_TYPE.LOCAL_STORAGE, STORAGE_TYPE.COOKIE, STORAGE_TYPE.NONE].indexOf(storage) > -1) {
      return storage;
    }

    return _getDefaultOptions().sType;
  };

  /**
   * Returns the time to live for the cache. Value is in milliseconds.
   * @param options
   * @returns {number}
   * @private
   */
  var _getStorageExpiry = function (options) {

    var _options = (_globalOptions) || options || {};

    var expiry = (_options.sExpiry || _options.storageExpiry) || _getDefaultOptions().sExpiry;

    return expiry;
  };

  var _getStorageKey = function (options) {
    var _options = options || (_globalOptions) || {};
    var key = (_options && (_options.sKey || _options.storageKey)) || null || _getDefaultOptions().sKey;

    return key;
  };

  var localStorageSupport = function () {
    return (localStorage && !!localStorage.getItem) || false;
  };

  /**
   * Gets the cached Value for the specified arguments
   *
   * @param args
   * @returns {*|null}
   * @private
   */
  var _getTTL = function (args) {
    var type = _getCurrentStorageType(args.options);

    if (type === STORAGE_TYPE.NONE) {
      return null;
    }
    var _options = { name: args.name, options: args.options };

    var value = null;
    if (type === STORAGE_TYPE.COOKIE) {
      value = _getCookie(_options);
    }
    else if (type === STORAGE_TYPE.LOCAL_STORAGE) {
      value = _getLocalStorage(_options);
    }

    if (value && typeof value === 'string') {
      value = JSON.parse(value);
    }

    return value;
  };

  var _getCacheValue = function (options) {
    return _getTTL({ name: _getStorageKey(options), options: options });
  };

  var _getCookie = function(args) {

    if (!document.cookie) {
      return null;
    }

    if (_getCurrentStorageType(args.options) === STORAGE_TYPE.NONE) {
      return null;
    }

    var cookies = document.cookie.split(';');

    var name = args.name;
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var cookieParts = cookie.split('=');

      if (cookieParts.length === 2 && !!cookieParts[0] && cookieParts[0].trim() === name) {
        return cookieParts[1];
      }
    }
    return null;
  };

  /**
   * Returns the DV storage value
   *
   * When the item is expired or invalid, a value of '' is returned
   *
   * Otherwise, the value is returned.
   *
   * @param args ({ name, options })
   * @returns {string | null}
   * @private
   */
  var _getLocalStorage = function (args) {
    if (!localStorageSupport()) {
      return null;
    }

    if (_getCurrentStorageType(args.options) === STORAGE_TYPE.NONE) {
      return null;
    }

    var name = args.name;
    var cachedProperties = window.localStorage.getItem(name);
    if (!cachedProperties) {
      return null;
    }

    var item = '';

    try {
      item = JSON.parse(cachedProperties);
    } catch(e) {
      localStorage.removeItem(name);
      return null;
    }
    if ((new Date()).getTime() > item.expiry) {
      localStorage.removeItem(name);
      return null;
    }

    var value = null;

    if (item && item.value !== undefined || item.value !== null) {
      value = item.value;
    }
    return value;
  };

  var _setTTL = function (response, options) {
    var type = _getCurrentStorageType(options);

    if (type === STORAGE_TYPE.COOKIE) {
      _setCookie({ options: response, data: response});
    }
    else if (type === STORAGE_TYPE.LOCAL_STORAGE) {
      _setLocalStorage({ options: response, data: response});
    }
  };

  var _setCookie = function(args) {

    var options = args.options;
    var value = args.data;

    if (_getCurrentStorageType(options) === STORAGE_TYPE.NONE) {
      return;
    }

    var expiryDate = new Date();
    var cacheKey = _getStorageKey();

    var expiry = _getStorageExpiry(options);
    if (expiry === undefined || expiry === null) {
      expiry = DEFAULT_OPTIONS.THIRTY_MINUTES_IN_MILLIS;
    }

    expiryDate.setTime(expiryDate.getTime() + expiry);

    var valueToStore = value || { value: DEFAULT_OPTIONS.CACHE_VALUE };
    if (typeof valueToStore === 'object') {
      valueToStore = JSON.stringify(valueToStore);
    }

    if (document.cookie.indexOf(cacheKey + '=' + valueToStore) === -1) {
      document.cookie = cacheKey + '=' + valueToStore + ';expires=' + expiryDate.toUTCString() + ';path=/';
    }

    localStorage.removeItem(cacheKey);
  };

  var _setLocalStorage = function (args) {

    var options = args.options;
    var value = args.data;

    if (_getCurrentStorageType(options) === STORAGE_TYPE.NONE) {
      return;
    }

    var valueToStore = value || { value: DEFAULT_OPTIONS.CACHE_VALUE };
    if (typeof valueToStore === 'object') {
      valueToStore = JSON.stringify(valueToStore);
    }

    var cacheKey = _getStorageKey();

    var expiry = _getStorageExpiry(options);
    if (expiry === undefined || expiry === null) {
      expiry = DEFAULT_OPTIONS.THIRTY_MINUTES_IN_MILLIS;
    }

    var item = { value: valueToStore, expiry: (new Date().getTime() + expiry) };
    window.localStorage.setItem(cacheKey, JSON.stringify(item));

    var defaultCacheValue = JSON.stringify({ value: DEFAULT_OPTIONS.CACHE_VALUE });
    var expiryDate = new Date(0).toUTCString();

    document.cookie = cacheKey + '=' + defaultCacheValue + ';expires=' + expiryDate + ';path=/';
  };

  /**
   * Default options for the DeviceValidation Library
   * @returns {
   *   licence: string,
   *   s2s: boolean,
   *   imei: IMEI: string (boolean in legacy setup),
   *   customUrlMode: boolean,
   *   onError: function,
   *   onSuccess: function,
   *   urls: string[],
   *   sType: string,
   *   sKey: string,
   *   sExpiry: string
   * }
   */
  function _getDefaultOptions() {
    return {
      licence: undefined,
      method: undefined,
      s2s: false,
      imei: null,
      customUrlMode: false,
      onSuccess: undefined,
      onError: undefined,
      urls: ["https://api1.devicevalidation.io/check","https://api2.devicevalidation.io/check","https://api3.devicevalidation.io/check"],
      tags: null,
      sExpiry: DEFAULT_OPTIONS.THIRTY_MINUTES_IN_MILLIS,
      sKey: DEFAULT_OPTIONS.CACHE_KEY,
      sType: STORAGE_TYPE.LOCAL_STORAGE // can also be STORAGE_TYPE.COOKIE or STORAGE_TYPE.NONE
    };
  }

  /**
   * The last stop after the DeviceAtlasCollector onPropertiesUpdate is called.
   *
   * @param options
   */
  var runCheckAuto = function(options) {
    propertiesLoadComplete = true;

    var dvOptions = options;
    if (!dvOptions) {
      dvOptions = {};
    }

    var _args = {
      s2s: isServerToServer(dvOptions),
      licence: dvOptions.licence,
      onSuccess: dvOptions.onSuccess,
      onError: dvOptions.onError,
      storageType: _getCurrentStorageType(dvOptions),
    };

    if (dvOptions && dvOptions.hasOwnProperty('imei')) {
      _args.imei = dvOptions.imei;
    }

    if (dvOptions && dvOptions.method) {
      _args.method = dvOptions.method;
    }

    var serverToServer = isServerToServer(_args);

    if (serverToServer && _args.onSuccess) {

      if (dvOptions.hasOwnProperty('imei')) {
        getApiClient().getDevicePropertiesWithIMEI(_args.imei, _args);
      }
      else {
        getApiClient().getDeviceProperties({
          callback: _args.onSuccess,
          method: _args.method
        });
      }
    }
    else if (!serverToServer && isValidLicenceKey(_args)) {
      if (!dvOptions.hasOwnProperty('imei')) {
        getApiClient().validateDevice(_args);
      }
      else if (!_legacyMode) {
        getApiClient().validateDeviceWithIMEI(_args.imei, _args);
      }
    }
  };

  // Adding additional properties requested from DV-1324
  var getAdditionalWebProperties = function(deviceAtlasProperties) {
    var webJsProps = {};

    // Copy properties from deviceAtlasProperties
    var _i, prop;
    if (deviceAtlasProperties) {
      var deviceAtlasPropertyKeys = Object.keys(deviceAtlasProperties);
      for (_i = 0; _i < deviceAtlasPropertyKeys.length; _i++) {
        webJsProps[deviceAtlasPropertyKeys[_i]] = deviceAtlasProperties[deviceAtlasPropertyKeys[_i]];
      }
    }

    // Add navigator properties
    var props = ['deviceMemory', 'oscpu', 'platform', 'productSub', 'webdriver'];
    for (_i = 0; _i < props.length; _i++) {
      prop = props[_i];
      if (typeof navigator[prop] !== 'undefined') {
        webJsProps['navigator.' + prop] = navigator[prop];
      }
    }

    // Add connection property
    if ('connection' in navigator && navigator.connection.saveData) {
      webJsProps["navigator.saveData"] = navigator.connection.saveData;
    }

    // Add screen properties
    var screenProps = ['width', 'height', 'availWidth', 'availHeight'];
    for (_i = 0; _i < screenProps.length; _i++) {
      prop = screenProps[_i];
      if (typeof window.screen[prop] !== 'undefined') {
        webJsProps['screen.' + prop] = window.screen[prop];
      }
    }

    // Add ApplePaySession property
    if (typeof window.ApplePaySession !== 'undefined') {
      webJsProps.applePaySession = !!window.ApplePaySession;
    }

    webJsProps['eval.length'] = eval.toString().length;
    webJsProps.hasVibrationApi = typeof navigator.vibrate === 'function' ? !!navigator.vibrate : false;
    webJsProps.promises = isPromiseSupported();

    webJsProps = detectPropertiesForiOS(webJsProps);

    _collectBraveData(webJsProps);
    _collectOperaData(webJsProps);
    _collectSafariData(webJsProps);
    _collectOrientationType(webJsProps);
    _collectNavigatorVendor(webJsProps);
    _collectNavigatorVendorSub(webJsProps);
    _collectNavigatorPlugins(webJsProps);
    _collectPluginsPrototypes(webJsProps);
    _collectDimensions(webJsProps);
    _collectCrypto(webJsProps);
    _detectAutomation(webJsProps);
    _collectSecureContext(webJsProps);
    _collectLocationData(webJsProps);
    _collectScreenAvailTop(webJsProps);
    _collectDocumentReadyState(webJsProps);
    _collectWindowChrome(webJsProps);
    _collectWindowIframe(webJsProps);

    _collectBrowserErrorID(webJsProps);
    _collectHasIndexedDB(webJsProps);
    _collectIsAppleDevice(webJsProps);
    _collectJsHeapSizeLimit(webJsProps);
    _collectLocalStoragePersistence(webJsProps);

    NavigatorCollector.collect(webJsProps);
    NavigatorStorageCollector.collect(webJsProps);

    _detectWebApiPermissions();

    return _addApiData(webJsProps);
  };

  /**
   * Returns the status of the document, it can be one of the following:
   * - loading
   * - interactive
   * - complete
   *
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/readyState
   *
   * @param webJsProps
   * @returns {*}
   * @private
   */
  var _collectDocumentReadyState = function (webJsProps) {

    webJsProps.document_readyState = _collectData(function () {
      if (document && document.readyState) {
        return document.readyState;
      }
    });

    return webJsProps;
  };

  /**
   * Collects the presence of the window.chrome property
   * @param webJsProps
   * @private
   */
  var _collectWindowChrome = function (webJsProps) {
    if (typeof window.chrome !== 'undefined') {
      webJsProps.window_chrome = _collectData(function () { return !!window.chrome; });
    }
  };

  /**
   * Detects if the current window is contained within an iframe
   * @param webJsProps
   * @private
   */
  var _collectWindowIframe = function (webJsProps) {
    webJsProps.window_iframe = _collectData(function () {
      return window && window.self !== window.top;
    });
  };

  /**
   * Collects whether the crypto object is available in the window object
   * @param webJsProps
   * @private
   */
  var _collectCrypto = function (webJsProps) {
    webJsProps.window_crypto = _collectData(function () {
      return _hasCrypto();
    });
  };

  /**
   * Adds the api data collected to the webJsProps passed in.
   */
  var _addApiData = function (webJsProps) {
    if (!apiData) {
      return webJsProps || {};
    }

    var jsApiKeys = Object.keys(apiData);
    for (var i = 0; i < jsApiKeys.length; i++) {
      var api = jsApiKeys[i];

      if (!!api) {
        webJsProps[api] = apiData[api];
      }
    }

    return webJsProps || {};
  };

  /**
   * Detects the geb bot
   * @returns {{a: boolean, e: boolean, v: *[]}}
   */
  var _detectGeb = function() {
    return _detectKeys(['geb']);
  };

  /**
   * https://fminer.findmysoft.com/
   * @returns {{a: boolean, e: boolean, v: *[]}}
   */
  var _detectFMiner = function() {
    return _detectKeys(['fmget_targets']);
  };

  /**
   * Collects the awesomium keys
   * https://developer.valvesoftware.com/wiki/Implementing_Awesomium
   *
   * Seems to be dead
   *
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectAwesomium = function () {
    return _detectKeys(['awesomium']);
  };

  /**
   * https://github.com/chromiumembedded/cef
   * Seems to detect this
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectCef = function () {
    return _detectKeys(['RunPerfTest']);
  };

  /**
   * https://cefsharp.github.io/
   * https://github.com/cefsharp/CefSharp
   * Seems to detect this
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectCefSharp = function () {
    return _detectKeys(['Cef']);
  };

  /**
   * Collects keys used for web automation
   *  window
   *  'webdriver',
   *  '__webdriverFunc',
   *  '__lastWatirAlert',
   *  '__lastWatirConfirm',
   *  '__lastWatirPrompt',
   *  '_WEBDRIVER_ELEM_CACHE',
   *  'ChromeDriverw'
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectWebdriverWindowKeys = function () {
    return _detectKeys([
      'lastWatir',
      'driver',
      'asyncScriptInfo',
      'driver'
    ]);
  };

  /**
   * Collects keys used for web automation
   * 'webdriver',
   *  '__webdriverFunc',
   *  '__lastWatirAlert',
   *  '__lastWatirConfirm',
   *  '__lastWatirPrompt',
   *  '_WEBDRIVER_ELEM_CACHE',
   *  'ChromeDriverw'
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectWebdriverDocumentKeys = function () {
    return _detectKeys([
      'lastWatir',
      'driver',
      'asyncScriptInfo',
      'driver'
    ], 'document');
  };

  /**
   * Detects the presence of any phantom keys
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectPhantomKeys = function () {
    return _detectKeys(['Phantom']);
  };

  /**
   * Detects the presence of any rhino keys
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectRhinoKeys = function () {
    return _detectKeys(['rhino', 'spawn']);
  };

  /**
   * Detects the presence of any rhino keys
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectCouchJS = function () {
    return _detectKeys(['couch', 'emit']);
  };

  /**
   * Detects the presence of any nodejs keys
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectBufferKeys = function () {
    return _detectKeys(['Buffer']);
  };

  /**
   * Detects the presence of any domAutomation keys. Used by BrowserStack and the like
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectDomAutomationKeys = function () {
    return _detectKeys(['domAutomation']);
  };


  /**
   * Returns whether the plugins key is present in the navigator object
   *
   * @returns {boolean}
   */
  var _isNavigatorPluginsAvailable = function () {
    return 'plugins' in navigator || typeof navigator.plugins !== 'undefined';
  };

  /**
   * Collects the dimensions for the window object.
   * When the outerWidth and outerHeight are 0, then it could be a sign of headless
   * @param webJsProps
   * @returns {*}
   * @private
   */
  var _collectDimensions = function (webJsProps) {
    var keys = ['outerWidth', 'outerHeight', 'innerWidth', 'innerHeight'];

    for (var i = 0; i < keys.length; i++) {
      var _key = keys[i];
      var _value = typeof window[_key] !== 'undefined' ? window[_key] : null;
      webJsProps['window_' + _key] = { a: _key in window, v: _value };
    }

    if (webJsProps.window_outerWidth && webJsProps.window_outerWidth.a && webJsProps.window_outerHeight && webJsProps.window_outerHeight.a) {
      webJsProps.window_hidden =  webJsProps.window_outerWidth.v === 0 && webJsProps.window_outerHeight.v === 0;
    }

    return webJsProps;
  };


  /**
   * Converts the plugin object to a base64 string
   * @param _plugin
   * @returns {string|null}
   */
  var _convertPlugin = function (_plugin) {
    if (_plugin && typeof _plugin !== 'undefined') {
      return btoa(_plugin.name + STRING_SEPARATOR + _plugin.filename + STRING_SEPARATOR + _plugin.description);
    }
    return null;
  };

  /**
   * Collects all the navigator plugins if they are available
   * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/plugins
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _collectNavigatorPlugins = function (webJsProps) {

    webJsProps.navigator_plugins = _collectData(function () {
      if (!_isNavigatorPluginsAvailable()) {
        return null;
      }
      var values = [];
      for (var i = 0; i < navigator.plugins.length; i++) {
        if (navigator.plugins[i]) {
          values.push(_convertPlugin(navigator.plugins[i]));
        }
      }

      return values;
    });

    return webJsProps;
  };

  /**
   * Collects the navigator vendor property
   * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/vendor
   * @param webJsProps
   * @returns {*}
   * @private
   */
  var _collectNavigatorVendor = function (webJsProps) {
    webJsProps.navigator_vendor = _collectData(function () {
      return typeof navigator.vendor !== 'undefined' ? navigator.vendor : null;
    });

    return webJsProps;
  };

  /**
   * Collects the navigator vendorSub property
   * https://developer.mozilla.org/en-US/docs/Web/API/Navigator/vendorSub
   * @param webJsProps
   * @returns {*}
   * @private
   */
  var _collectNavigatorVendorSub = function (webJsProps) {
    webJsProps.navigator_vendorSub = _collectData(function () {
      return typeof navigator.vendorSub !== 'undefined' ? navigator.vendorSub : null;
    });

    return webJsProps;
  };

  /**
   * Collects the navigator plugins prototype
   * https://github.com/infosimples/detect-headless/blob/master/scripts/detect_headless.js
   * When this is false, its a headless browser
   * @param webJsProps
   * @returns {*}
   * @private
   */
  var _collectPluginsPrototypes = function (webJsProps) {
    webJsProps.navigator_plugins_prototype = _collectData(function () {

      if (!_isNavigatorPluginsAvailable()) {
        return null;
      }

      var value = PluginArray.prototype ===  Object.getPrototypeOf(navigator.plugins);
      if (navigator.plugins.length > 0) {
        value = value && Plugin.prototype === Object.getPrototypeOf(navigator.plugins[0]);
      }
      return value;
    });

    return webJsProps;
  };

  /**
   * Hook method to collect all the automation framework data
   * @param webJsProps
   * @private
   */
  var _detectAutomation = function (webJsProps) {
    var automation = {
      phantom: _detectPhantomKeys(),
      rhino: _detectRhinoKeys(),
      buffer: _detectBufferKeys(),
      domAutomation: _detectDomAutomationKeys(),
      couch: _detectCouchJS(),
      cdc: _detectChromeDriver(),
      karma: _detectKarmaKeys(),

      geb: _detectGeb(),
      fminer: _detectFMiner(),
      awesomium: _detectAwesomium(),
      cef: _detectCef(),
      cefsharp: _detectCefSharp(),
      webdriver_window: _detectWebdriverWindowKeys(),
      webdriver_document: _detectWebdriverDocumentKeys(),

      window_nightmare: _detectNightmareInWindow(),
      document_nightmare: _detectNightmareInDocument(),
      window_selenium: _detectSeleniumInWindow(),
      document_selenium: _detectSeleniumInDocument(),
      window_cypress: _detectCypressInWindow(),
      document_cypress: _detectCypressInDocument(),

      document: _detectDocumentKeys()
    };

    var _data = webJsProps;
    if (!_data) {
      _data = {};
    }

    try {
      var automationKeys = Object.keys(automation);

      for (var i = 0; i < automationKeys.length; i++) {
        var _key = automationKeys[i];
        if (automation[_key].a) {
          _data[_key] = automation[_key];
        }
      }
    }
    catch (e) {}

    return _data;
  };

  /**
   * Detects the presence of any Karma keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectKarmaKeys = function () {
    return _detectKeys(['karma']);
  };

  /**
   * Detects the presence of any Test keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectTestKeys = function () {
    return _detectKeys(['test']);
  };

  /**
   * Detects the presence of any Chrome Driver keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectChromeDriver = function () {
    return _detectKeys(['cdc']);
  };

  /**
   * Detects the presence of any Nightmare keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectNightmareInWindow = function () {
    return _detectKeys(['Nightmare']);
  };

  /**
   * Detects the presence of any Nightmare keys in the document object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectNightmareInDocument = function () {
    return _detectKeys(['Nightmare'], 'document');
  };


  /**
   * Detects the presence of any Cypress keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectCypressInWindow = function () {
    return _detectKeys(['Cypress']);
  };


  /**
   * Detects the presence of any Cypress keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectCypressInDocument = function () {
    return _detectKeys(['Cypress'], 'document');
  };

  /**
   * Detects the presence of any Selenium keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectSeleniumInWindow = function () {
    return _detectKeys(['Selenium']);
  };

  /**
   * Detects the presence of any Selenium keys in the window object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectSeleniumInDocument = function () {
    return _detectKeys(['Selenium'], 'document');
  };

  /**
   * Detects the presence of any Document keys in the document object
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectDocumentKeys = function () {
    return _detectKeys([
      'func',
      'fn',
      'evaluate',
      'unwrapped',
      'driver',
      'fx',
      '_'
    ], 'document');
  };


  /**
   * Detects the presence of any keys in the object passed in
   * @param detections
   * @param type
   * @returns {{a: boolean, e: boolean, v: *[]}}
   * @private
   */
  var _detectKeys = function (detections, type) {
    var _result = { a: false, v: [], e: false };
    var foundKeys = {};
    var _keys = type === 'document' ? _getDocumentKeys() : type === 'navigator' ? _getNavigatorKeys() : _getWindowKeys();

    for (var i = 0; i < _keys.length; i++) {
      var _key = _keys[i];
      if (!_key) continue;

      for (var j = 0; j < detections.length; j++) {
        try {
          var detection = detections[j];
          if (_key.toLowerCase().indexOf(detection.toLowerCase()) > -1) foundKeys[_key] = i;
        } catch (e) {
          _result.e = true;
        }
      }
    }

    _result.v = Object.keys(foundKeys);
    _result.a = _result.v.length > 0;
    return _result;
  };

  /**
   * Returns a list of keys within the window object
   * @param flush
   * @returns {*|*[]}
   * @private
   */
  var _getWindowKeys = function (flush) {
    try {
      return __getCacheKey(flush,'window', window);
    }
    catch (e) {
      return [];
    }
  };

  /**
   * Returns a list of keys within the document object
   * @param flush
   * @returns {*|*[]}
   * @private
   */
  var _getDocumentKeys = function (flush) {
    try {
      return __getCacheKey(flush,'document', document);
    }
    catch (e) {
      return [];
    }
  };

  /**
   * Returns a list of keys within the navigator object
   * @param flush
   * @returns {*|*[]}
   * @private
   */
  var _getNavigatorKeys = function (flush) {
    try {
      return __getCacheKey(flush,'navigator', navigator);
    }
    catch (e) {
      return [];
    }
  };

  /**
   * Gets a list of keys within the object passed in and stores that list in the cache.
   * @param flush
   * @param key
   * @param obj
   * @returns {*}
   * @private
   */
  var __getCacheKey = function (flush, key, obj) {
    if (flush && !!_cache[key]) {
      delete _cache[key];
    }

    if (!_cache[key]) {
      _cache[key] = Object.keys(obj);
    }

    return _cache[key];
  };

  var __flushCache = function () {
    if (_cache) {

      try {
        var _cacheKeys = Object.keys(_cache);
        for (var i = 0; i < _cacheKeys.length; i++) {
          delete _cache[_cacheKeys[i]];
        }

        _cache = {};
      }
      catch(e) {}
    }
  };

  /**
   * Tests the behaviour of the localStorage object in the window object.
   * @param webJsProps
   * @private
   */
  var _collectLocalStoragePersistence = function (webJsProps) {

    if (!window || !window.localStorage) {
      return;
    }

    webJsProps.localStorage = _collectData(function () {
      try {
        window.localStorage.setItem('DeviceAssure', '1');
        window.localStorage.removeItem('DeviceAssure');
      }
      catch (e) {
        return 'error';
      }
      return 'available';
    });
  };


  /**
   * Method to test the collection of the indexedDB upgrade needed
   *
   * @param event
   * @param db
   * @param args
   * @param dbName
   * @param _apiData
   * @private
   */
  var _collectIndexDBUpgradeNeeded = function (event, db, args, dbName, _apiData) {
    var _value = null;

    var _db = (event && event.target && event.target.result) || null;

    try {
      _db.createObjectStore(dbName, { autoIncrement: true }).put(new Blob());
    }
    catch (error) {
      _value = error;
      if (error && error.message) {
        _value = error.message;
      }
      else if (typeof _value === 'string' && _value.indexOf('BlobURLs are not yet supported') > -1) {
        _value = 'BlobURLs are not yet supported';
      }
    }
    finally {
      if (_db && _db.close) {
        _db.close();
      }
      if (db && db.close) {
        db.close();
      }
      // Remove our test database
      if (indexedDB && indexedDB.deleteDatabase && dbName) {
        indexedDB.deleteDatabase(dbName);
      }
    }

    if (_value) {
      var _result = _collectData(function () { return _value; });
      _result.e = true;
      _apiData.indexedDB_persistence = _result;
    }

    if (args && args.resolve) {
      args.resolve(_apiData.indexedDB_persistence);
    }
  };

  /**
   * Determines if writing to the indexedDB is possible. Used to help identify incognito mode in safari.
   * @param args - { resolve, reject }
   * @param _apiData - {}
   * @private
   */
  var _collectIndexedDBPersistence = function (args, _apiData) {

    if (!window.indexedDB) {
      _apiData.indexedDB_persistence = { a: false, e: false  };
      if (args && args.resolve) {
        args.resolve(_apiData.indexedDB_persistence);
      }
      return;
    }

    try {
      var dbName = 'DeviceAssure_' + Date.now();
      var db = window.indexedDB.open(dbName);

      db.onupgradeneeded = function (event) {
        _collectIndexDBUpgradeNeeded(event, db, args, dbName, _apiData);
      };
    }
    catch (e) {
      _apiData.indexedDB_persistence = { a: true, e: true };

      if (args && args.resolve) {
        args.resolve(_apiData.indexedDB_persistence);
      }
    }
  };


  /**
   * This is used as a way to detect chrome incognito mode from version 50 to 75.
   *
   * @param args - { resolve, reject }
   * @param _apiData - { }
   * @private
   */
  var _collectWebkitRequestFileSystem = function (args, _apiData) {

    var callback = function (result) {

      _apiData.webkitRequestFileSystem = _collectData(function () { return result; });
      _apiData.webkitRequestFileSystem.e = 'error' === result;

      if (args && args.resolve) {
        args.resolve(_apiData.webkitRequestFileSystem);
      }
    };

    if (window.webkitRequestFileSystem) {
      window.webkitRequestFileSystem(0, 1, function () { callback('success'); }, function () { callback('error'); });
    }
    else if (args && args.resolve) {
      args.resolve();
    }
  };

  /**
   * Collect the client hints separately to device atlas to see if there's any discrepancy between
   * the two. At the time of writing, the default values for the client hints are:
   * - brands
   * - mobile
   * - platform
   *
   * @private
   */
  var _collectMinimumClientHints = function (args, _apiData) {

    if (!navigator || !navigator.userAgentData || !navigator.userAgentData.getHighEntropyValues) {

      if (args && args.resolve) {
        args.resolve();
      }
      return;
    }

    // Requesting empty client hints to see if there's any discrepancy between the DA one.
    navigator.userAgentData.getHighEntropyValues([])
      .then(function (values) {

        _apiData.clientHintsMinimum = { a: true, e: false, v: values };

        if (args && args.resolve) {
          args.resolve(_apiData.clientHintsMinimum);
        }
      })
      .catch(function () {

        if (!_apiData.clientHintsMinimum) {
          _apiData.clientHintsMinimum = {};
        }
        _apiData.clientHintsMinimum.a = true;
        _apiData.clientHintsMinimum.e = true;

        if (args && args.resolve) {
          args.resolve(_apiData.clientHintsMinimum);
        }
      });
  };


  /**
   * Adds sensor object to the jsProps passed in.
   */
  var _detectWebApiPermissions = function () {

    if (!apiData) {
      apiData = {};
    }

    // DeviceMotion and DeviceOrientation events should be true in iOS
    // IdleDetector events should be true in chrome [desktop]
    var apis = [
      'DeviceMotionEvent',
      'DeviceOrientationEvent',
      'DeviceMotionEventAcceleration',
      'DeviceMotionEventRotationRate',

      'IdleDetector',

      'DragEvent',
      'GestureEvent' // Looks to be Apple only
    ];

    for (var i = 0; i < apis.length; i++) {
      var apiName = apis[i];

      if (!apiName){
        continue;
      }

      apiData[apiName] = {
        available: !!window[apiName],
        requiresPermission: _apiRequiresPermissions(apiName)
      };
    }

    return apiData;
  };

  /**
   * Records if the specified api requires permissions to run a sensor.
   */
  var _apiRequiresPermissions = function (apiName) {
    if (!apiName) {
      return false;
    }

    var requestPermission = (!!window[apiName] && window[apiName].requestPermission) || null;

    return typeof requestPermission === 'function';
  };

  var _collectData = function (dataFunction, args) {
    return Common.collectData(dataFunction, args);
  };

  /**
   * Attempts to collect the orientation type
   * @param webJsProps
   */
  var _collectOrientationType = function (webJsProps) {
    var orientation_data = _collectData(function () {
      return window.screen.orientation.type;
    });

    webJsProps.screen_orientation_type = orientation_data;
  };

  /**
   * Attempts to identify if the brave properties are present.
   * @param webJsProps
   * @returns
   */
  var _collectBraveData = function (webJsProps) {

    webJsProps.brave = {
      available: false
    };

    if (!navigator.brave || typeof navigator.brave.isBrave !== 'function') {
      return;
    }

    webJsProps.brave.available = true;
  };

  var _collectOperaData = function (webJsProps) {

    webJsProps.opera = {
      available: false
    };

    if (window.opr) {
      webJsProps.opera.available = true;
    }
  };

  var _collectSafariData = function (webJsProps) {

    webJsProps.safari = {
      available: false
    };

    if (!window.safari || typeof safari.pushNotification !== 'function') {
      return;
    }

    webJsProps.safari.available = true;
  };

  /**
   * Returns whether sessionStorage is available or not.
   *
   * @returns {boolean}
   * @private
   */
  var _hasSessionStorage = function () {
    return 'sessionStorage' in window && window.sessionStorage !== null;
  };

  /**
   * Returns whether crypto is available or not.
   *
   * @returns {boolean}
   * @private
   */
  var _hasCrypto = function () {

    if ('crypto' in window && !!window.crypto) {
      return !!window.crypto.randomUUID && !!window.crypto.getRandomValues;
    }

    return false;
  };

  /**
   * Collects the jsHeapSizeLimit from the performance object. Used in detection of chrome incognito mode.
   *
   * @param webJsProps
   * @private
   */
  var _collectJsHeapSizeLimit = function (webJsProps) {
    if (!window.performance || !window.performance.memory || typeof window.performance.memory.jsHeapSizeLimit === 'undefined') {
      return;
    }

    webJsProps.jsHeapSizeLimit = _collectData(function () {
      if (window.performance && window.performance.memory) {
        return window.performance.memory.jsHeapSizeLimit;
      }
    });
  };

  /***
   *
   * Each Browser engine returns a different value for this function.
   *
   * Chrome: 51
   * Firefox: 25
   * Safari: 44
   * PhantomJS: 43
   *
   * */
  var _getFixedEngineID = function () {
    var _engineID = 0;

    try {
      (-1).toFixed(-1);
    } catch (e) {
      _engineID = e.message.length;
    }

    return _engineID;
  };

  /**
   * Collects whether the js engine is Apple's
   * @param webJsProps
   * @private
   */
  var _collectIsAppleDevice = function (webJsProps) {
    initIsAppleDevice();

    if (isAppleDevice) {
      webJsProps.apple = _collectData(function () {
        if (isAppleDevice) {
          return isAppleDevice;
        }
      });
    }
  };

  /**
   * Collects what type of browser it is from the length of the default error message.
   * @param webJsProps
   * @private
   */
  var _collectBrowserErrorID = function (webJsProps) {
    webJsProps.browserErrorID = _collectData(function () { return _getFixedEngineID(); });
  };

  var _collectHasIndexedDB = function (webJsProps) {
    webJsProps.indexedDB = _collectData(function () {
      if (typeof window.indexedDB !== 'undefined') {
        return true;
      }
    });
  };


  /**
   * Collects the secure context data
   * @param {*} webJsProps
   */
  var _collectSecureContext = function (webJsProps) {

    var secureContextData = _collectData(function () {
      return window.isSecureContext;
    });

    webJsProps['window_isSecureContext'] = secureContextData;
  };


  var _collectLocationData = function (webJsProps) {

    var locationOrigin = _collectData(function () {
      return window.location.origin;
    });

    webJsProps['window_location_origin'] = locationOrigin;

    var locationProtocol = _collectData(function () {
      return window.location.protocol;
    });

    webJsProps['window_location_protocol'] = locationProtocol;

    var locationHost   = _collectData(function () {
      return window.location.host;
    });

    webJsProps['window_location_host'] = locationHost;
  };

  /**
   * Attempts to collect the screen.availTop
   * @param webJsProps
   */
  var _collectScreenAvailTop = function (webJsProps) {
    var availTop = _collectData(function () {
      return window.screen.availTop;
    });

    webJsProps.screen_availTop = availTop;
  };

  var detectPropertiesForiOS = function (webJsProps) {

    var jsProps = webJsProps;
    if (!jsProps) {
      jsProps = {};
    }

    // iPhone simulator does not have these properties yet.
    jsProps['document.pictureInPictureElement'] = document.pictureInPictureElement ? true : null;


    var pictureInPictureEnabled = false;
    if (document.pictureInPictureEnabled || document.pictureInPictureEnabled === false) {
      pictureInPictureEnabled = document.pictureInPictureEnabled;
    }

    jsProps['document.pictureInPictureEnabled'] = pictureInPictureEnabled;

    // iPads and Browsers have these properties.
    jsProps['document.webkitCancelFullScreen'] = document.webkitCancelFullScreen ? true : null;
    jsProps['document.webkitExitFullScreen'] = document.webkitExitFullScreen ? true : null;
    jsProps['document.webkitCurrentFullScreenElement'] = document.webkitCurrentFullScreenElement ? true : null;
    jsProps['document.webkitFullscreenElement'] = document.webkitFullscreenElement ? true : null;

    var webkitFullscreenEnabled = false;
    if (document.webkitFullscreenEnabled || document.webkitFullscreenEnabled === false) {
      webkitFullscreenEnabled = document.webkitFullscreenEnabled;
    }
    jsProps['document.webkitFullscreenEnabled'] = webkitFullscreenEnabled;

    var webkitFullScreenKeyboardInputAllowed = false;
    if (document.webkitFullScreenKeyboardInputAllowed || document.webkitFullScreenKeyboardInputAllowed === false) {
      webkitFullScreenKeyboardInputAllowed = document.webkitFullScreenKeyboardInputAllowed;
    }
    jsProps['document.webkitFullScreenKeyboardInputAllowed'] = webkitFullScreenKeyboardInputAllowed;

    // iOS property
    jsProps['navigator.standalone'] = typeof navigator.standalone !== 'undefined' ? navigator.standalone : null;

    return jsProps;
  };

  var initIsAppleDevice = function() {
    if (typeof isAppleDevice === 'undefined') {
      isAppleDevice = NavigatorCollector.isAppleUserAgent(navigator);
    }
  };

  var getDevicePropsAsString = function() {

    devicePropertiesAsString = (_getDeviceAtlasCollector().getPropertiesAsString && _getDeviceAtlasCollector().getPropertiesAsString()) || '';

    if (typeof devicePropertiesAsString !== 'string') {
      devicePropertiesAsString = '';
    }

    return devicePropertiesAsString;
  };

  var getDeviceAtlasProperties = function () {
    var properties = (_getDeviceAtlasCollector().getProperties && _getDeviceAtlasCollector().getProperties()) || {};

    if (typeof properties !== 'object') {
      properties = {};
    }

    return properties;
  };


  /**
   * Cleans the existing entries for the variant ids in the session storage. It will not remove other library versions
   * that are present in the session storage.
   *
   * The result is a single entry in session storage for the variant id for this library version.
   *
   * @returns {number|string}
   * @private
   */
  function _generateVariantId() {
    var id = _uuidv4();

    if (!id) {
      return Date.now();
    }

    if (!_hasSessionStorage()) {
      return id;
    }

    var sessionKeys = Object.keys(window.sessionStorage);
    for (var i = 0; i < sessionKeys.length; i++) {
      var key = sessionKeys[i];
      if (key.indexOf(_getVariantPrefix()) > -1) {
        window.sessionStorage.removeItem(key);
      }
    }

    var entry = {
      completed: false,
      date: Date.now()
    };

    window.sessionStorage.setItem(_getVariantPrefix() + id, JSON.stringify(entry));

    return id;
  }

  /**
   * Completes the session in the sessionStorage and then attempts to clean the rest of the variants
   * in the session storage.
   *
   * @private
   */
  function _completeSession() {

    if (!_hasSessionStorage()) {
      return;
    }

    try {
      var key = _getVariantId();
      var entry = window.sessionStorage.getItem(key);

      if (entry) {
        var obj = JSON.parse(entry);
        obj.completed = true;
        window.sessionStorage.setItem(key, JSON.stringify(obj));
      }
    }
    catch (e) {
      window.sessionStorage.setItem(_getVariantId(), JSON.stringify({ completed: true, error: true, date: Date.now() }));
    }
    _purgeVariants();
  }

  /**
   * Returns the variant id for this library version.
   *
   * @returns {string}
   * @private
   */
  function _getVariantId() {
    return _getVariantPrefix() + VARIANT_ID;
  }

  /**
   * Returns the variant prefix for this library version.
   * @returns {string}
   * @private
   */
  function _getVariantPrefix() {
    return VARIANT_PREFIX;
  }

  /**
   * Cleans all the variants if they are present in the session storage and have a value of 'completed': true.
   *
   * @private
   */
  function _purgeVariants() {

    VARIANT_ID = '';

    if (!_hasSessionStorage()) {
      return;
    }

    var libraryKeys = [];
    var allCompleted = true;
    var sessionKeys = Object.keys(window.sessionStorage);

    var i;
    for (i = 0; i < sessionKeys.length; i++) {
      var key = sessionKeys[i];

      if (key.indexOf(VARIANT_PREFIX_BASE) > -1) {
        libraryKeys.push(key);

        var entry = window.sessionStorage.getItem(key);
        if (entry) {
          var obj = JSON.parse(entry);
          if (!obj.completed) {
            allCompleted = false;
            break;
          }
        }
      }
    }

    if (allCompleted) {
      for (i = 0; i < libraryKeys.length; i++) {
        window.sessionStorage.removeItem(libraryKeys[i]);
      }
    }
  }


  /**
   * Builds the variants block of the payload.
   * The ids are a concatenated string of the variant ids.
   * The count is the number of variants in the string.
   *
   * @returns {{count: number, ids: string}}
   * @private
   */
  var _buildVariants = function () {
    var ids = '';
    var count = 0;

    if ('sessionStorage' in window) {

      var sessionKeys = Object.keys(window.sessionStorage);

      for (var i = 0; i < sessionKeys.length; i++) {

        var key = sessionKeys[i];
        if (key.indexOf(VARIANT_PREFIX_BASE) > -1) {

          var parts = key.split(STRING_SEPARATOR);

          if (parts.length > 1) {
            var variantId = parts[parts.length - 1];
            ids = ids + variantId + STRING_SEPARATOR;
            count++;
          }
        }
      }

      // Trim the last two '__'
      if (ids.length > 2) {
        ids = ids.substring(0, ids.length - 2);
      }
    }

    return {
      ids: ids,
      count: count
    };
  };


  /**
   * Crypto is only available in secure contexts, so we need to generate a UUIDv4 if it is not available.
   *
   * Found here: https://stackoverflow.com/a/8809472
   *
   * @returns {string}
   * @private
   */
  function _uuidv4() {

    if (_hasCrypto()) {
      return window.crypto.randomUUID();
    }

    // Fallback for when the crypto object is not available
    try {
      var d = new Date().getTime();
      var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;
        if(d > 0){
          r = (d + r)%16 | 0;
          d = Math.floor(d/16);
        } else {
          r = (d2 + r)%16 | 0;
          d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    }
    catch (e) {}

    return '';
  }

  /* jshint ignore:start */
  
  /* jshint ignore:end */


  function _createMissingPropertyAttempt(attempt, type) {

    if (!type) {
      type = MESSAGE_TYPES.WAIT_AUDIO_REF;
    }

    return {
      isFirst: attempt === 1,
      date: Date.now(),
      attempt: attempt,
      present: false,
      type: type
    };
  }

  /**
   * Function is triggered onLoad of the DeviceAtlas library and when we detect any changes.
   * @param properties
   * @param propertiesAsString
   */
  function _onPropertiesUpdate(properties, propertiesAsString) {
    _initialised++;

    getDataCollector().collect(MESSAGE_TYPES.DA_MESSAGE, true);
  }

  /**
   * Checks whether the daProps string passed in has the audioRef in it or not.
   * @returns {boolean}
   * @private
   */
  function _hasAudioRef() {
    var daProps = getDeviceAtlasProperties();

    var audioRef = (daProps && daProps.audioRef) || null;

    // common scenarios
    if ([null, 'null', '', 0].indexOf(audioRef) > -1) {
      return false;
    }

    return !!((audioRef + '').trim()); // check if present
  }

  /***
   * To tackle a situation where it is an Apple device but never gives back the audioRef then
   * wait for 1 second and continue with execution of the script.
   *
   * @param timeToWait
   * @param doRequest
   * @param type
   */
  function _asyncCheckForApple(timeToWait, doRequest, type) {

    if (type && type !== MESSAGE_TYPES.DA_MESSAGE && (!isAppleDevice || timeoutInitialized || hasExceededAttempts('AUDIO_REF'))) {
      return;
    }

    timeoutInitialized = true;
    WAIT_ATTEMPTS.AUDIO_REF++;

    if (!timeToWait || timeToWait < 1) {
      timeToWait = DEFAULT_TIME_TO_WAIT;
    }

    var asyncCheck = function() {
      timeoutInitialized = false;

      if (!isAppleDevice) {
        return;
      }

      var audioRefProperties = !!missingProperties.audioRef ? missingProperties.audioRef : [];
      var attempt = _createMissingPropertyAttempt(audioRefProperties.length + 1, MESSAGE_TYPES.WAIT_AUDIO_REF);

      // Flag that our audioRef was missing or present for this attempt.
      attempt.present = _hasAudioRef();
      audioRefProperties.push(attempt);

      missingProperties.audioRef = audioRefProperties;

      var exceeded = hasExceededAttempts('AUDIO_REF');

      // Attempt to find the audioRef at most 10 times, total time to take should be between 100ms to 300ms
      if (!attempt.present && !exceeded) {
        _asyncCheckForApple(timeToWait, doRequest, MESSAGE_TYPES.WAIT_AUDIO_REF);
      }
      else if (doRequest || exceeded) {
        runCheckAuto(_globalOptions, type);
      }
    };

    setTimeout(asyncCheck, timeToWait);
  }

  /**
   * Detect if WebGLRenderingContext has been overridden
   *
   * @returns Object
   * @private
   */
  function _detectWebGlOverrides() {

    var _callback = function () {
      if (!WebGLRenderingContext || !WebGLRenderingContext.prototype || !Object || !Object.getOwnPropertyDescriptor) {
        return undefined;
      }

      var descriptor = Object.getOwnPropertyDescriptor(WebGLRenderingContext.prototype, 'getParameter');

      return _buildCanvasOverrideResult(descriptor, [], ['[native code]']);
    };

    return _collectData(_callback);
  }

  function _detectHTMLCanvasOverridesGetContext() {
    var _callback = function () {
      if (!HTMLCanvasElement || !HTMLCanvasElement.prototype || !Object || !Object.getOwnPropertyDescriptor) {
        return undefined;
      }

      var descriptor = Object.getOwnPropertyDescriptor(HTMLCanvasElement.prototype, 'getContext');

      return _buildCanvasOverrideResult(descriptor, [], ['[native code]']);
    };

    return _collectData(_callback);
  }


  /**
   * Builds the result of the HTMLCanvasElement overrides.
   *
   * Broken out so it can be unit tested and gain coverage. It's never overridden in test code.
   *
   * @param descriptor
   * @param ignored - properties to not include
   * @param ignoredValues - values to not include
   * @returns {{}}
   * @private
   */
  function _buildCanvasOverrideResult(descriptor, ignored, ignoredValues) {

    var _result;
    if (descriptor) {
      _result = {};
      if (!ignored || ignored.indexOf('enumerable') === -1) {
        _result.enumerable = descriptor.enumerable;
      }

      if (!ignored || ignored.indexOf('writable') === -1) {
        _result.writable = descriptor.writable;
      }

      if (!ignored || ignored.indexOf('configurable') === -1) {
        _result.configurable = descriptor.configurable;
      }

      if ((!ignored || ignored.indexOf('get') === -1) && typeof descriptor.get !== 'undefined' && descriptor.get.toString().indexOf('[native code]') < 0) {
        _result.getter = descriptor.get.toString();
      }

      if ((!ignored || ignored.indexOf('set') === -1) && typeof descriptor.set !== 'undefined' && descriptor.set.toString().indexOf('[native code]') < 0) {
        _result.setter = descriptor.set.toString();
      }

      if ((!ignored || ignored.indexOf('value') === -1) && typeof descriptor.value !== 'undefined') {
        var _value;

        if (typeof descriptor.value === 'object') {
          _value = JSON.stringify(descriptor.value);
        } else {
          _value = descriptor.value.toString();
        }
        _result.value = _value;
      }
    }

    return _result;
  }

  /**
   * Collects the options the library was run with.
   *
   * @param payload
   * @param options
   * @private
   */
  function _appendRequestConfigs(payload, options) {
    if (!payload || !payload.data || !payload.data.web || !payload.data.web.webview || !payload.data.web.webview.jsProps) {
      return;
    }

    var configs = _collectData(function (_args) {

      if (!_args) {
        return;
      }

      var imei, s2s;
      if (payload.data.telephony) {
        imei = payload.data.telephony.imei;
      }

      if (payload.info && payload.info.serverToServer) {
        s2s = payload.info.serverToServer;
      }

      var method = _args.method || 'onPropertiesUpdate';

      var result = {
        method: method,
        onSuccess: !!_args.onSuccess,
        onError: !!_args.onError,
        storageType: _args.storageType,
        storageExpiry: _args.storageExpiry
      };

      if (_scriptAttributes) {
        var scriptKeys = Object.keys(_scriptAttributes);
        for (var i = 0; i < scriptKeys.length; i++) {
          var key = scriptKeys[i];
          result[key] = _scriptAttributes[key];
        }
      }

      if (_args.urls) {
        result.urls = _args.urls;
      }

      if (typeof s2s !== 'undefined') {
        result.serverToServer = s2s;
      }

      if (typeof imei !== 'undefined') {
        result.imei = !!imei && imei.toString();
      }

      if (payload.info && payload.info.legacy) {
        result.legacy = true;
      }

      return result;
    }, options);

    if (configs && payload && payload.data && payload.data.web && payload.data.web.webview && payload.data.web.webview.jsProps) {
      payload.data.web.webview.jsProps.configs = configs;
    }
  }

  /**
   * Collects all the overrides that have been detected.
   *
   * @returns {{a: boolean, e: boolean}}
   * @private
   */
  function _collectOverrides() {
    var _callback = function () {
      if (!Object && Object.getOwnPropertyDescriptor && typeof Object.getOwnPropertyDescriptor === 'function') {
        return undefined;
      }

      var properties = [];

      if (document) {
        properties.push({
          object: document,
          name: 'document',
          properties: ['readyState', 'referrer']
        });
      }

      if (navigator) {
        properties.push({
          object: navigator,
          name: 'navigator',
          properties: [
            'userAgentData',
            'appCodeName',
            'appName',
            'appVersion',
            'brave',
            'buildID',
            'languages',
            'language',
            'platform',
            'userAgent',
            'hardwareConcurrency',
            'deviceMemory',
            'oscpu',
            'webdriver',
            'maxTouchPoints',
            'product',
            'bluetooth',
            'clipboard',
            'connection',
            'cookieEnabled',
            'hid',
            'ink',
            'geolocation',
            'plugins',
            'vendor',
            'vendorSub',
            'permissions',
            'serviceWorker',
            'getBattery'
          ]
        });

        if (navigator.permissions) {
          properties.push({
            object: navigator.permissions,
            name: 'navigator_permissions',
            properties: ['query']
          });
        }

        if (navigator.userAgentData) {
          properties.push({
            object: navigator.userAgentData,
            name: 'navigator_userAgentData',
            properties: ['getHighEntropyValues']
          });
        }
      }

      if (window) {
        properties.push({
          object: window,
          name: 'window',
          properties: [
            'indexedDB',
            'performance',
            'innerWidth',
            'innerHeight',
            'outerWidth',
            'outerHeight',
            'isSecureContext',
            'orientation',
            'statusbar',
            'toolbar',
            'visualViewport',
            'chrome',
            'opr',
            'opera',
            'origin',
            'safari',
            'screen',
            'speechSynthesis',
            'ApplePaySession',
          ]
        });

        if (window.screen) {
          properties.push({
            object: window.screen,
            name: 'window_screen',
            properties: ['width', 'height', 'deviceXDPI', 'deviceYDPI']
          });
        }

        if (window.performance && window.performance.memory) {
          properties.push({
            object: window.performance.memory,
            name: 'window_performance_memory',
            properties: ['jsHeapSizeLimit', 'totalJSHeapSize', 'usedJSHeapSize']
          });
        }
      }
      return _detectPropertyOverrides(properties);
    };


    var allOverrides = _collectData(_callback);
    var webGlOverrides = _detectWebGlOverrides();
    var htmlCanvasContextOverrides = _detectHTMLCanvasOverridesGetContext();

    if (webGlOverrides && webGlOverrides.a) {
      if (!allOverrides || (allOverrides && !allOverrides.v)) {
        allOverrides = { a: allOverrides.a, e: allOverrides.e, v: {} };
      }

      allOverrides.a = allOverrides.a || webGlOverrides.a;
      allOverrides.e = allOverrides.e || webGlOverrides.e;
      allOverrides.v.WebGLRenderingContext = webGlOverrides;
    }

    if (htmlCanvasContextOverrides && htmlCanvasContextOverrides.a) {
      if (!allOverrides || (allOverrides && !allOverrides.v)) {
        allOverrides = { a: allOverrides.a, e: allOverrides.e, v: {} };
      }

      allOverrides.a = allOverrides.a || htmlCanvasContextOverrides.a;
      allOverrides.e = allOverrides.e || htmlCanvasContextOverrides.e;
      allOverrides.v.HTMLCanvasElement = htmlCanvasContextOverrides;
    }

    return allOverrides;
  }

  /**
   * Creates a list of properties that have been overridden based off the properties passed in.
   * @param properties
   * @returns {*[]}
   * @private
   */
  var _detectPropertyOverrides = function (properties) {

    if (!properties || properties.length < 1) {
      return undefined;
    }
    var overrides;

    var _callback = function (args) {
      var obj = args.object;
      var prop = args.prop;

      var descriptor = Object.getOwnPropertyDescriptor(obj, prop);

      var _result = _buildCanvasOverrideResult(descriptor, ['enumerable', 'writable', 'configurable']);
      if (!_result) {
        return undefined;
      }

      if (descriptor.writable) {
        _result.writable = descriptor.writable.toString();
      }
      return Object.keys(_result).length > 0 ? _result : undefined;
    };

    var i, j;
    for (i = 0; i < properties.length; i++) {
      var obj = properties[i].object;
      var name = properties[i].name;
      var props = properties[i].properties || [];

      for (j = 0; j < props.length; j++) {

        var args = { object: obj, prop: props[j] };


        var _result = _collectData(_callback, args);
        if (_result && _result.a) {
          if (!overrides) {
            overrides = {};
          }
          overrides[name + '_' + args.prop] = _result;
        }
      }
    }
    return overrides;
  };

  /**
   * Removes the spaces found at the end of the string.
   * @param str
   * @param character
   * @returns {string|string|*}
   */
  function _trimEnd(str, character) {
    if (str === null || str === undefined || typeof str !== 'string') {
      return null;
    }

    while (str.charAt(str.length - 1) === (character || ' ')) {
      str = str.slice(0, -1);
    }

    return str;
  }

  /**
   * Removes the spaces found at the start of the string.
   * @param str
   * @param character
   * @returns {string|string|*}
   */
  function _trimStart(str, character) {
    if (str === null || str === undefined || typeof str !== 'string') {
      return null;
    }

    while (str.charAt(0) === (character || ' ')) {
      str = str.slice(1);
    }

    return str;
  }

  /**
   * Trims the start and end of a string.
   *
   * @param str
   * @param character
   * @returns {string|*}
   * @private
   */
  function _trim(str, character) {
    var _str = _trimStart(str, character);
    return _trimEnd(_str, character);
  }

  /**
   * Initialises the DeviceValidation configurations
   *
   * @private
   */
  function _initDV(DV, _options) {
    var overridingOptions = null;

    if (window.DeviceValidation && window.DeviceValidation.options) {
      overridingOptions = window.DeviceValidation.options;
    }
    else if (_options) {
      overridingOptions = _options;
    }

    if (!overridingOptions) {
      return;
    }

    _overriddenConfig = {};

    var options = _getDefaultOptions();

    if (overridingOptions.serverToServer === true) {
      options.s2s = overridingOptions.serverToServer;
      _overriddenConfig.s2s = true;
    }

    if (!!overridingOptions.licence) {
      options.licence = _trim(overridingOptions.licence, ' ');
      _overriddenConfig.licence = true;
    }

    if (overridingOptions.hasOwnProperty('imei')) {
      options.imei = overridingOptions.imei;
      _overriddenConfig.imei = true;
    }
    else {
      delete options.imei;
    }

    if (overridingOptions.urls && overridingOptions.urls.length > 0) {

      var validUrls = [];
      for (var _i = 0; _i < overridingOptions.urls.length; _i++) {
        if (!overridingOptions.urls[_i]) {
          continue;
        }
        var url = _trim(overridingOptions.urls[_i], ' ');
        if (url) {
          validUrls.push(url);
        }
      }

      options.urls = validUrls;
      options.customUrlMode = true;
      delete options.licence;
      _overriddenConfig.urls = true;
    }

    if (overridingOptions.onSuccess) {
      options.onSuccess = overridingOptions.onSuccess;
      _overriddenConfig.onSuccess = true;
    }

    if (overridingOptions.onError) {
      options.onError = overridingOptions.onError;
      _overriddenConfig.onError = true;
    }

    var _storageType = _trim(overridingOptions.storageType, ' ');
    if ([STORAGE_TYPE.COOKIE, STORAGE_TYPE.LOCAL_STORAGE, STORAGE_TYPE.NONE].indexOf(_storageType) > -1) {
      options.sType = _storageType;
      _overriddenConfig.sType = true;
    }

    if (options.sType !== STORAGE_TYPE.NONE && overridingOptions.storageExpiry &&
      overridingOptions.storageExpiry > 0 && overridingOptions.storageExpiry <= DEFAULT_OPTIONS.TWENTY_FOUR_HOURS_IN_MILLIS) {

      options.sExpiry = overridingOptions.storageExpiry;
      _overriddenConfig.sExpiry = true;
    }

    if (_options && _options.method) {
      options.method = _options.method;
    }

    if (_options && _options.tags) {
      options.tags = validateTags(_options.tags);
    }

    if (_overriddenConfig.licence && _overriddenConfig.urls) {
      throw new Error('Licence key cannot be used in conjunction with custom urls');
    }

    VARIANT_ID = _generateVariantId();

    _globalOptions = options;

    return DV;
  }

  function _isCustomUrlMode() {
    if (!_globalOptions) {
      return false;
    }
    return (!_globalOptions.licence && _globalOptions.customUrlMode) || false;
  }

  /**
   * Return the DeviceAtlasCollector instance. This is the DeviceAtlas Clientside library
   * @returns {*}
   * @private
   */
  function _getDeviceAtlasCollector() {
    if (!_DeviceAtlasCollector) {
      _DeviceAtlasCollector = {};
    }

    return _DeviceAtlasCollector;
  }

  /**
   * Returns the DataCollector instance. This is the DeviceValidation library's collector
   * @returns {*}
   */
  function getDataCollector() {
    if (!DataCollector) {
      DataCollector = {};

      DataCollector.createPromiseCollection = function (args) {
        if (args && typeof args.collection === 'function' && isPromiseSupported()) {
          return new Promise(function(resolve, reject) {
            if (!apiData) {
              apiData = {};
            }
            args.collection({ resolve: resolve, reject: reject }, apiData);
          });
        }
        return null;
      };

      /**
       * Returns the async properties that need to be collected.
       * The name property isn't used anywhere, but helps with debugging.
       * @returns [{ name: string, collection: function }]
       */
      DataCollector.getAsyncProperties = function () {

        var collections = [
          { name: 'client_hint_lies',                   collection: _collectMinimumClientHints },
          { name: 'window_webkitRequestFileSystem',     collection: _collectWebkitRequestFileSystem },
          { name: 'window_indexedDB_createObjectStore', collection: _collectIndexedDBPersistence },
        ];

        var propertyCollections = NavigatorStorageCollector.getCollectionsForAsync();

        var _i;
        for (_i = 0; _i < propertyCollections.length; _i++) {
          collections.push(propertyCollections[_i]);
        }
        propertyCollections = NavigatorCollector.getCollectionsForAsync();
        for (_i = 0; _i < propertyCollections.length; _i++) {
          collections.push(propertyCollections[_i]);
        }
        return collections;
      };

      DataCollector.collectProperties = function (callback) {

        if (apiData || !isPromiseSupported()) {
          callback();
          return;
        }

        if (!apiData) {
          apiData = {};
        }

        var asyncProperties = DataCollector.getAsyncProperties();
        var collections = [];
        for (var _i = 0; _i < asyncProperties.length; _i++) {
          var promise = DataCollector.createPromiseCollection(asyncProperties[_i]);
          if (promise) {
            collections.push(promise);
          }
        }

        // Adding a promise to make sure we don't wait forever for the async properties to resolve.
        var timeoutPromise = new Promise(function(resolve, reject) {
          setTimeout(function() {
            apiData.promiseTimeout = true;
            resolve({ timeout: true });
          }, PROMISE_TIMEOUT);
        });

        _metrics.asyncStart = Date.now();
        Promise.race([Promise.all(collections), timeoutPromise]).then(function(results) {
          _metrics.asyncFinished = Date.now();

          var callbackArgs = {
            asyncStart: _metrics.asyncStart,
            asyncFinished: _metrics.asyncFinished
          };
          if (results && results.timeout) {
            callbackArgs.timeout = true;
          }
          callback(callbackArgs);
        });
      };

      /***
       * Triggers the collecting of the device data using the DA library, when doRequest is true, it will
       * perform the check call.
       *
       * @param type
       * @param doRequest
       */
      DataCollector.collect = function (type, doRequest) {

        var _collectNonBlockingProperties = function () {
          initIsAppleDevice();

          if (!type) {
            type = MESSAGE_TYPES.ON_LOAD;
          }

          if ((type === MESSAGE_TYPES.ON_LOAD || !doRequest) && isServerToServer(_globalOptions)) {
            // don't do any collection for server to server for the audioRef. It is done onPropertyUpdate
            return;
          }

          var noWait;

          // no audio ref, record we're missing it.
          if (isAppleDevice) {
            var audioRefProperties = !!missingProperties.audioRef ? missingProperties.audioRef : [];
            var attempt = _createMissingPropertyAttempt(audioRefProperties.length + 1, type);
            attempt.present = _hasAudioRef();

            // Flag that our audioRef was missing for this attempt.
            audioRefProperties.push(attempt);
            missingProperties.audioRef = audioRefProperties;

            noWait = attempt.present;
          } else {
            noWait = doRequest && (!isAppleDevice || _hasAudioRef());
          }


          if (noWait) {
            runCheckAuto(_globalOptions);
          } else {
            _asyncCheckForApple(DEFAULT_TIME_TO_WAIT, doRequest, type);
          }
        };

        getDataCollector().collectProperties(_collectNonBlockingProperties);
      };
    }

    return DataCollector;
  }

  /**
   * Throws an error when invalid imei is passed in.
   *
   * @param imei
   * @param options
   * @private
   */
  function _validateIMEI(imei, options) {
    var rules = [
      {
        message: 'IMEI is not a string.',
        valid: function (_imei) {
          // conditions for when the IMEI is not a string. (usually is from a input field)
          return typeof imei === 'string';
        }
      },
      {
        message: 'IMEI is not present, please provide one.',
        valid: function (_imei) {
          var trimmedImei = _trim(_imei, ' ');

          // Conditions for when the imei is all whitespace
          if (!trimmedImei || !isImeiEnabled(options)) {
            return false;
          }
          return true;
        }
      }
    ];
    for (var _i = 0; _i < rules.length; _i++) {
      if (rules[_i].valid(imei)) {
        continue;
      }

      var disabledError = { message: rules[_i].message };

      if (options && options.onError) {
        options.onError(disabledError);
        return false;
      }
      throw disabledError;
    }

    return true;
  }

  /**
   * Set of rules for validation of a licence.
   * @param _licence
   * @param options
   * @returns {boolean}
   * @private
   */
  function _validateLicence(_licence, options) {

    if (_isCustomUrlMode()) {
      return true;
    }

    var rules = [
      {
        message: 'Invalid licence key.',
        valid: function (_value) {
          if (typeof _value !== 'string') {
            return false;
          }
          return true;
        }
      },
      {
        message: 'Invalid licence key.',
        valid: function (_value) {
          if (!_value || _value.indexOf('LICENCE') > -1) {
            return false;
          }
          return true;
        }
      },
      {
        message: 'Invalid licence key.',
        valid: function (_value) {
          var trimmedValue = _trim(_value, ' ');

          if (!trimmedValue || !trimmedValue.length) {
            return false;
          }

          return true;
        }
      }
    ];
    for (var _i = 0; _i < rules.length; _i++) {
      if (rules[_i].valid(_licence)) {
        continue;
      }

      var disabledError = { message: rules[_i].message };

      if (options && options.onError) {
        options.onError(disabledError);
        return false;
      }
      throw disabledError;
    }

    return true;
  }

  /**
   * Returns the API client object.
   * getDeviceProperties - returns the device properties for the server to server check.
   * validateDevice - triggers the API call to check the device.
   * validateDeviceWithIMEI - triggers the API call to check the device for IMEI validation.
   * _loadLegacy - Loads the legacy mode of the DeviceValidation library.
   * load - Loads the DeviceValidation library.
   * @returns {*}
   */
  function getApiClient() {
    if (!ApiClient) {
      ApiClient = {};
      /**
       * Returns the server to server payload for the device validation check.
       *
       * @param args.callback - callback function to call with the payload
       * @returns {*}
       * @private
       */
      ApiClient.getDeviceProperties = function (args) {

        var callback = (args && args.callback) || undefined;

        if (!callback || propertiesLoadComplete || getPropertiesTimeoutInitialized) {
          return getPayloadData(callback, buildPayload, args);
        }

        getPropertiesTimeoutInitialized = true;
        setTimeout(function(callback, buildPayloadFunc, args) {
          return getPayloadData(callback, buildPayloadFunc, args);
        }, 1000, callback, buildPayload, args);
      };

      /**
       * Builds the Server to Server request with IMEI added to the payload
       * @param imei
       * @param params
       * @returns {*}
       */
      ApiClient.getDevicePropertiesWithIMEI = function (imei, params) {

        var options = params || {};
        var onSuccess = (options && options.onSuccess) || null;

        if (!_validateIMEI(imei, options)) {
          return;
        }

        if (!onSuccess || propertiesLoadComplete || getPropertiesTimeoutInitialized) {
          return getPayloadData(onSuccess, _buildIMEIPayload, options);
        }

        getPropertiesTimeoutInitialized = true;
        setTimeout(function(callback, buildPayloadFunc, _params) {
          return getPayloadData(callback, buildPayloadFunc, _params);
        }, 1000, onSuccess, _buildIMEIPayload, params);
      };

      /**
       * Entrypoint method for the DeviceValidation library, used for legacy mode.
       * @param _options
       * @returns {{}}
       * @private
       */
      ApiClient._loadLegacy = function(_options) {
        var options = _getDefaultOptions();

        delete options.licence;
        if (!!_options.licence) {
          options.licence = _options.licence;
        }

        delete options.urls;
        if (!!_options.urls) {
          options.urls = _options.urls;
        }

        options.onSuccess = _options.onSuccess || options.onSuccess;
        options.onError = _options.onError || options.onError;

        options.storageType = _options.storageType;
        options.storageExpiry = _options.storageExpiry;

        delete options.imei;
        if (_options.imei) {
          options.imei = _options.imei;
        }

        if (_options.serverToServer) {
          options.serverToServer = _options.serverToServer;
        }

        _legacyMode = true;

        return ApiClient.load(options);
      };

      /**
       * Entrypoint method for the DeviceValidation library. This will initialise the DeviceAtlas library and start the
       * collection of our properties.
       *
       * This replaces the old setup of declaring DeviceValidation = { options: {} } etc.
       *
       * @param _options
       * @returns {{}}
       */
      ApiClient.load = function(_options) {
        _metrics.load = Date.now();

        if (!VARIANT_ID) {
          VARIANT_ID = _generateVariantId();
        }

        var options = _options || null;

        if (STORAGE_TYPE.NONE === _getStorageType(options)) {
          _overriddenConfig = null;
          _globalOptions = {};
          _DeviceValidation.options = null;
        }
        else {
          var existingCache = _getCacheValue(options);
          if (options && !!existingCache && typeof options.onSuccess === 'function' && !isServerToServer(options)) {
            // Don't load other JS, we have a cache.
            options.onSuccess(existingCache);
            _completeSession();
            return _DeviceValidation;
          }
        }

        if (!window.DeviceAtlasCollector) {
          _initDA(options);
        }

        if (!_overriddenConfig) {
          _initDV(_DeviceValidation, options);
        }

        if (_initialised > 0) {
          runCheckAuto(options);
        }

        return _DeviceValidation;
      };

      /**
       * Init the entire library;
       * @returns {{}|*}
       */
      ApiClient.init = function () {
        _metrics.init = Date.now();

        if (document && document.currentScript) {
          if (!!document.currentScript.async) {
            _scriptAttributes.async = true;
          }

          if (!!document.currentScript.defer) {
            _scriptAttributes.defer = true;
          }

          if (!!document.currentScript.onload) {
            _scriptAttributes.onload = true;
          }

          if (document.currentScript.type) {
            _scriptAttributes.type = document.currentScript.type;
          }

          if (document.currentScript.src) {
            _scriptAttributes.src = btoa(document.currentScript.src);
          }
        }

        /**
         * The legacy configuration hook for the DeviceValidation library.
         *
         * This is needed for when DeviceValidation = { options: {} } is used. Please use DeviceValidation.load now.
         */
        if (window.DeviceValidation && !!window.DeviceValidation.options) {
          var apiClient = getApiClient();
          var legacyOptions = window.DeviceValidation.options;

          apiClient.initDeviceValidation(_DeviceValidation);
          return apiClient._loadLegacy(legacyOptions);
        }
        return getApiClient().initDeviceValidation(_DeviceValidation);
      };

      /**
       * Init the DeviceValidation library with the DeviceValidation object. Inserting in to the window
       * @param dv
       * @returns {{}}
       */
      ApiClient.initDeviceValidation = function (dv) {
        if (!window.DeviceValidation || !window.DeviceValidation.load) {
          window.DeviceValidation = dv;
        }

        return dv;
      };

      /**
       * Trigger to call the API check with the IMEI passed in. It will populate the data.telephony.imei and tac
       * @param imei
       * @param params
       * @returns {Promise|*|void}
       * @private
       */
      ApiClient.validateDeviceWithIMEI = function (imei, params) {
        var onSuccess = (params && params.onSuccess) || null;
        var onError = (params && params.onError) || null;
        var licence = (params && params.licence) || (_globalOptions && _globalOptions.licence) || '';

        var payload = (params && params.payload) || null;
        var overrideLoading = (params && params.overrideLoading) || false;

        var options = params || {};

        if (!_validateLicence(licence, options) || !_validateIMEI(imei, options)) {
          return;
        }

        payload = _buildIMEIPayload({ licence: licence, imei: imei, payload: payload});

        return getApiClient().validateDevice({
          licence: licence,
          onSuccess: onSuccess,
          onError: onError,
          payload: payload,
          currentUrl: currentUrl,
          overrideLoading: overrideLoading,
          imei: imei,
          method: params && params.method
        });
      };

      /**
       * Method which loads the device assure library depending on the arguments passed in.
       *
       * @param params.licence - licence key
       * @param params.imei - IMEI
       * @param params.onSuccess - callback function to call on success
       * @param params.onError - callback function to call on error
       * @param params.payload - [optional] Payload to send to the API.
       * @param params.method - [optional] How the library was called.
       * @param params.currentUrl - [optional] Url to send the request to (used for failover)
       * @param params.overrideLoading - [optional] override the loading flag, this can help to prevent calling the api if there
       *                                 is some form of external loading that should be needed to block this.
       * @param params.overridingURLs - [optional] Override the urls to send the request to.
       * @param params.urls           - [optional] Alias for overridingURLs
       * @returns {Promise|any|void}
       */
      ApiClient.validateDevice = function (params) {
        var overrideLoading = (params && params.overrideLoading) || false;
        var onSuccess = (params && params.onSuccess) || function () {};
        var onError = (params && params.onError) || function () {};
        var licence = (params && params.licence) || undefined;
        var payload = (params && params.payload) || undefined;
        var currentUrl = (params && params.currentUrl) || undefined;
        var overridingURLs = (params && (params.overridingURLs || params.urls)) || undefined;
        var imei = (params && params.imei) || undefined;
        var method = (params && params.method) || null;
        var storageType = _getCurrentStorageType(params);

        if (loading && !overrideLoading) {
          return;
        }

        var cachedResponse = _getCacheValue();
        var hasNoCache = STORAGE_TYPE.NONE === storageType || !cachedResponse;

        var apiParams = {
          licence: licence,
          onSuccess: onSuccess,
          onError: onError,
          suppliedPayload: payload,
          currentUrl: currentUrl,
          overrideLoading: overrideLoading,
          urls: overridingURLs,
          imei: imei,
          method: method
        };

        if (isPromiseSupported()) {
          return new Promise(function (resolve, reject) {

            if (hasNoCache) {
              apiParams.resolve = resolve;
              apiParams.reject = reject;

              return _doRequest(apiParams);
            }

            _completeSession();
            if (resolve) {
              resolve(cachedResponse);
            }
            if (onSuccess) {
              onSuccess(cachedResponse);
            }
            return cachedResponse;
          });
        }

        if (hasNoCache) {
          return _doRequest(apiParams);
        }
        if (onSuccess) {
          onSuccess(cachedResponse);
        }
        return cachedResponse;
      };
    }

    return ApiClient;
  }

  /**
   * Entrypoint method for the DeviceValidation library.
   *
   * This is the main entry point for the library, it will initialise the DeviceAtlas library and start the
   * collection of the properties.
   *
   * It replaces the old setup of declaring DeviceValidation = { options: {} } etc.
   *
   * Please use this going forward.
   *
   * @param _options
   * @returns {{}}
   */
  _DeviceValidation.load = function(_options) {
    getApiClient().load(_options);
  };

  /**
   * @deprecated - This method will be removed in future releases in favour of the load method.
   *
   * Function to return the payload for the device validation check.
   * accepts a callback function
   *
   * if callback is passed in then the callback is called with data else the payload is returned
   *
   * This will be removed in a future release, please use the async method in the future, some of the properties we
   * collect require a synchronous approach. For a more accurate result please use the async approach.
   *
   **/
  _DeviceValidation.getData = function(callback) {
    var args = { callback: callback, method: 'getData' };

    if (!window.DeviceAtlasCollector) {
      args.serverToServer = true;
      args.onSuccess = callback;

      _DeviceValidation.load(args);
    }
    else {
      return getApiClient().getDeviceProperties(args);
    }

  };

  /**
   * @deprecated - This method will be removed in future releases in favour of the load method.
   *
   * Trigger to call the API check with the IMEI passed in. It will populate the data.telephony.imei and tac
   * properties if present.
   *
   * @param imei - IMEI value
   * @param params - contains options to override the default values in the library loaded in on page load.
   * @returns {Promise<unknown>}
   */
  _DeviceValidation.checkIMEI = function(imei, params) {
    var args = params || {};
    if (!args.method) {
      args.method = 'checkIMEI';
    }

    // For when the library wasn't loaded. Use the arguments from here.
    if (!window.DeviceAtlasCollector) {
      args.imei = imei;
      _DeviceValidation.load(args);
    }
    else {
      return getApiClient().validateDeviceWithIMEI(imei, args);
    }
  };

  /**
   * @deprecated - This method will be removed in future releases in favour of the load method.     * Method which immediately calls the API to check the device.
   *
   * It is not recommended to use this method any more.
   *
   * If it is used on page load, it creates a race condition between the DeviceAtlas library and the API call.
   *
   * @param licence - licence key
   * @param onSuccess - callback function to call on success
   * @param onError - callback function to call on error
   * @param payload - [optional] Payload to send to the API.
   * @param currentUrl - [optional] Url to send the request to (used for failover)
   * @param overrideLoading - [optional] override the loading flag, this can help to prevent calling the api if there
   *                          is some form of external loading that should be needed to block this.
   * @param overridingURLs - [optional] Override the urls to send the request to.
   *
   * @returns {Promise|any|void}
   */
  _DeviceValidation.check = function(licence, onSuccess, onError, payload, currentUrl, overrideLoading, overridingURLs) {

    // For when the library wasn't loaded. Use the arguments from here.
    if (!window.DeviceAtlasCollector) {
      _DeviceValidation.load({
        licence: licence,
        onSuccess: onSuccess,
        onError: onError,
        method: 'check'
      });
    }
    else {
      return getApiClient().validateDevice({
        licence: licence,
        onSuccess: onSuccess,
        onError: onError,
        payload: payload,
        currentUrl: currentUrl,
        overrideLoading: overrideLoading,
        urls: overridingURLs,
        method: 'check'
      });
    }
  };

  /**
   * Initialisation for the DeviceAtlas & DeviceAssure web library.
   *
   * If we don't have a cookie or our cookie has expired, we will start to collect the DeviceAtlas properties in the
   * background.
   *
   * If we have a cookie that has not expired, we make no attempt to initialise the DeviceAtlas library.
   *
   * If server to server configs are enabled, then we override whatever cookie we have and collect the data.
   *
   * The collection of the data is done by not adding a DeviceAtlas object in to the window.
   *
   * @params _options
   * @returns {{}|{cacheType: string, onPropertiesUpdate: _onPropertiesUpdate}}
   */
  function _initDA(_options) {
    // Documentation for DA: https://docs.deviceatlas.com/apis/clientside/latest/README.ClientSide.html
    // CDN: https://cs.deviceatlas-cdn.com/dacs.js
    // noinspection UnnecessaryLocalVariableJS
    var _DeviceAtlasConfig = {
      onPropertiesUpdate: _onPropertiesUpdate,
      cacheType: 'none', // This means we do not cache the DA result.
      dontStopPropertyUpdateEvents: false,
      waitMilliSecondsToBulkSendProperties: 1
    };

    window.DeviceAtlasCollector = _DeviceAtlasConfig;
    // var DeviceAtlasCollector = is imported here so the DeviceAtlasCollector will be in this scope.

    /* jshint ignore:start */
    /*
 * Copyright 2025 DeviceAtlas Limited. All rights reserved.
 * http://deviceatlas.com
 */
var DeviceAtlasCollector=function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r})},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=2)}([function(e,t,n){"use strict";n.r(t);var r=function(e){return"string"==typeof e&&e&&(e=function(e){return(e+"").replace(/"/g,'\\"')}(e=function(e){return(e+"").replace(/\\/g,"\\\\")}(e))),e},o=function(e){if(void 0!==(t=e)&&Array.isArray(t))return(function(e){return e.map((function(e){return'"'+r(e.brand)+'";v="'+e.version+'"'})).join(", ")}(e)+"").replace(/:/g," ");var t};function i(e){return void 0!==e&&""!==e?'"'+r(e)+'"':e}var c=new Promise((function(e){var t=navigator&&navigator.userAgentData,n=function(n){var r={},c=encodeURIComponent(i(t.platform)),u=encodeURIComponent(o(t.brands));void 0!==t.mobile&&(r.requestingMobileUx=t.mobile),void 0!==c&&(r["ch.platform"]=c),void 0!==u&&(r["ch.browserList"]=u),e(r)};if(t)try{t.getHighEntropyValues(["architecture","bitness","brands","mobile","model","platform","platformVersion","uaFullVersion,","fullVersionList"]).then((function(t){var n={platformArchitecture:t.architecture,requestingMobileUx:t.mobile,"ch.model":encodeURIComponent(i(t.model)),"ch.platform":encodeURIComponent(i(t.platform)),"ch.browserList":encodeURIComponent(o(t.brands)),"ch.browserFullVersionList":encodeURIComponent(o(t.fullVersionList)),"ch.platformVersion":encodeURIComponent(i(t.platformVersion)),"ch.bitness":t.bitness},r={};for(var c in n)null!=n[c]&&"undefined"!==n[c]&&"null"!==n[c]&&(r[c]=n[c]);e(r)})).catch(n)}catch(e){n()}else e({})}));t.default=c},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.addEventListener}},function(e,t,n){"use strict";n.r(t),n.d(t,"cacheProperty",(function(){return U}));var r=n(8),o=n.n(r),i=n(10),c=n(13),u="._.".length,a=["ch.model","ch.platform","ch.browserList","ch.browserFullVersionList","ch.platformVersion"],s=function(e,t,n){for(var r in void 0===t&&(t=!1),void 0===n&&(n={}),e){var o=t?t+"."+r:r,i=e[r],c=typeof e[r];"object"!==c||Array.isArray(i)?"function"!==c&&"undefined"!==c&&(n[o]=i):s(i,o,n)}return n},f=function(e,t,o){void 0===t&&(t=function(e){void 0===e&&(e=["_uaVerRef","audioRef","ch.bitness","ch.browserFullVersionList","ch.browserList","ch.model","ch.platform","ch.platformVersion","connectionType","cookieSupport","css.animations","css.columns","css.transforms","css.transitions","ddg","deviceAspectRatio","devicePixelRatio","displayColorDepth","downlink","effectiveConnectionType","flashCapable","html.audio","html.canvas","html.inlinesvg","html.svg","html.video.ap4x","html.video.av1","html.video.av1016M08","html.video","js.accessDom","js.applicationCache","js.battery","js.deviceMotion","js.deviceOrientation","js.forceTouch","js.geoLocation","js.indexedDB","js.json","js.localStorage","js.modifyCss","js.modifyDom","js.querySelector","js.sessionStorage","js.supportBasicJavaScript","js.supportConsoleLog","js.supportEventListener","js.supportEvents","js.touchEvents","js.webGl","js.webGlRenderer","js.webSockets","js.webSqlDatabase","js.webWorkers","js.xhr","mouseActivity","orientation","platformArchitecture","rendererRef","requestingMobileUx","roundTripTime","saveData","screenWidthHeight","timeZone","usableDisplayHeight","usableDisplayWidth","userMedia"]);var t={};e.map((function(e){t[e]=n(17)("./"+e+".js").default}));var o=function(){};return r.criticalProperties.map((function(e){t[e]=t[e]||o})),t}()),void 0===o&&(o=!1);var i=function(n){var r,i=e[n];if(i||!t.hasOwnProperty(n))return 1;var c=t[n],u=c.length<=1;try{r=c(i,(function(e){_.cacheProperty(n,e,i)}),e)}catch(e){_.debug(e)}(o||u)&&_.cacheProperty(n,r,i)};for(var c in t)i(c)},l=function(e,t,n,r,o){var u;switch(e){case"cookie":u=function(e){if(!Object(i.default)())return"";for(var t=e+"=",n=document.cookie.split(";"),r=0;r<n.length;r++){for(var o=n[r];" "===o.charAt(0);)o=o.substring(1);if(0===o.indexOf(t)){var c=o.substring(t.length,o.length);'"'===c.charAt(0)&&(c=c.substr(1));var u=c.length-1;return'"'===c[u]&&(c=c.substring(0,u)),c}}return""}(r);break;case"local-storage":u=function(e){if(!Object(c.default)())return"";var t=window.localStorage.getItem(e);if(!t)return"";var n="";try{n=JSON.parse(t)}catch(t){return localStorage.removeItem(e),""}return(new Date).getTime()>n.expiry?(localStorage.removeItem(e),""):n.value}(t);break;default:return}return function(e,t){if(!e||""===e)return t;for(var n=e.replace(/\%7C/g,"|").split("|"),r=0;r<n.length;r++){var o=n[r],i=o.indexOf("%3A"),c=!0;-1===i&&(c=!1,i=o.indexOf(":"));var u=o.substr(0,1),s=o.substr(1,i-1);if("timeTook"!==s){var f=o.substring(i+(c?"%3A".length:":".length));switch(-1===a.indexOf(s)&&(f=decodeURIComponent(f)),u){case"i":t[s]=1*f;break;case"b":t[s]=!!(1*f);break;default:t[s]=f}}}return t}(u,o)},d=(new Date).getTime(),v="undefined"!=typeof window&&window.DeviceAtlasCollector||{},p="function"==typeof v.debug?v.debug:v.debug&&console&&console.log?console.log:function(){},m=v.properties||{},h=v.cacheKey||"DAPROPS",y=v.cookieName||"DAPROPS",g=v.cacheType||"cookie",b=v.criticalProperties||o.a.criticalProperties,j=v.waitMilliSecondsToBulkSendProperties||3e3,w=v.cookieExpiryDays||1,k=v.cacheExpiryDays||1,x=v.dontStopPropertyUpdateEvents||!1,O=void 0!==v.encodeCookieValue&&Boolean(v.encodeCookieValue),E=v.cookieDomain||null,S=v.cookiePath||"/",T="function"==typeof v.onPropertiesUpdate?v.onPropertiesUpdate:function(){},D=!1,P=function(e,t){D&&!x||(T(e,t),D=!0)},C=[],A=!1,R=function(e,t){(function(e,t){if(!Array.isArray(e)||!Array.isArray(t))return!1;for(var n=0;n<e.length;n++)if(!~t.indexOf(e[n]))return!1;return!0})(b,C)&&(A&&(clearTimeout(A),A=!1),P(e,t))},L=function(){return(new Date).getTime()-d+"ms"},M=function(){return function(e){var t,n,r="";for(var o in e)e.hasOwnProperty(o)&&"timeTook"!==o&&"S"!==o&&"E"!==o&&(r+=(t="boolean"==typeof(n=e[o])?"b":"number"==typeof n&&n%1==0?"i":"s")+o+":"+("b"===t?e[o]+0:e[o])+"|");return"bS:0|"+r+"bE:0"}(V)},V={csVersion:"2.6"},U=function(e,t,n){if(C.push(e),void 0!==t&&null!=t&&t!==n)switch("object"==typeof t?function(e,t,n){var r=s(t,e),o=void 0;for(var i in r)if(void 0!==r[i]){var c=i.indexOf("._.");n[~c?i.substring(c+u):i]=r[i],o=o||!!r[i]}}(e,t,V):V[e]=t,g){case"cookie":!function(e,t){var n=t.cookieName,r=t.cookieExpiryDays,o=t.cookieDomain,c=t.cookiePath,u=t.encodeCookieValue;if(!Object(i.default)())return!1;var s=new Date;s.setDate(s.getDate()+r);var f="";null!=o&&(f=";domain="+o),u&&(e=e.split("|").map((function(e){var t=e.split(":",2),n=t[0].substring(1);return-1===a.indexOf(n)&&(t[1]=encodeURIComponent(t[1])),t.join("%3A")})).join("%7C")),document.cookie=n+'="'+e.replace(/;/g,"~")+'";expires='+s.toUTCString()+";path="+c+f}(M(),{cookieName:y,cookieDomain:E,cookieExpiryDays:w,cookiePath:S,encodeCookieValue:O});break;case"local-storage":!function(e,t,n){if(!Object(c.default)())return!1;var r=(new Date).getTime()+864e5*n;window.localStorage.setItem(t,JSON.stringify({value:e,expiry:r}))}(M(),h,k)}V.timeTook=L(),R(V,M())},_=t.default={cookieName:y,cookieDomain:E,cookieExpiryDays:w,cookiePath:S,onPropertiesUpdate:T,csVersion:"2.6",getPropertiesAsString:M,getProperties:function(){return V},properties:V,debug:p,cacheProperty:U},B=!0;try{B=!0}catch(e){}B&&(l(g,h,0,y,V),C.push.apply(C,Object.keys(V)),f(V),f(V,m,!0),A=setTimeout((function(){V.timeTook=L(),P(V,M())}),j))},function(e,t,n){"use strict";var r=n(11),o=(n(2),["Webkit","Moz","O","ms","Khtml"]);t.a=function(e){var t=e.charAt(0).toUpperCase()+e.substr(1),n=(e+" "+o.join(t+" ")+t).split(" ");return Object(r.a)(n)}},function(e,t,n){"use strict";t.a=function(e){if(document.createElement)try{var t=document.createElement("video");if(t.canPlayType)switch(t.canPlayType(e)){case"":return!1;case"probably":return!0}}catch(e){}}},function(e,t,n){"use strict";var r=["webkit","moz","o","ms","khtml"];t.a=function(e,t){if(!!e[t])return!0;for(var n=t.charAt(0).toUpperCase()+t.substr(1),o=-1,i=r.length;++o<i;)if(e[r[o]+n])return!0;return!1}},function(e,t,n){"use strict";n.r(t);var r=navigator&&navigator.connection||{};t.default=r},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.CanvasRenderingContext2D}},function(e,t){e.exports={criticalProperties:["deviceAspectRatio","devicePixelRatio","js.webGlRenderer","screenWidthHeight","rendererRef","audioRef","js.deviceMotion","html.video.ap4x","html.video.av1","ch.bitness","ch.browserFullVersionList","ch.browserList","ch.model","ch.platform","ch.platformVersion","html.video.av1016M08","usableDisplayWidth","usableDisplayHeight","_uaVerRef"]}},function(e,t,n){"use strict";t.a=function(e,t){t=t||5381;for(var n=0;n<e.length;n++)t=33*t^e.charCodeAt(n);return String(t>>>0)}},function(e,t,n){"use strict";n.r(t),t.default=function(){return void 0===navigator.cookieEnabled&&"string"==typeof document.cookie||!!navigator.cookieEnabled}},function(e,t,n){"use strict";var r=n(2);t.a=function(e){if(!document.createElement)return null;if(null==r.default.divStyle&&(r.default.divStyle=document.createElement("div").style),void 0===r.default.divStyle)return null;for(var t in e)if(void 0!==r.default.divStyle[e[t]])return!0;return!1}},function(e,t,n){"use strict";t.a=function(e,t){if(void 0!==window.matchMedia)for(var n in t){if(window.matchMedia("("+e+":"+t[n]+")").matches)return t[n]+""}}},function(e,t,n){"use strict";n.r(t),t.default=function(){try{return!!localStorage.getItem}catch(e){return!1}}},function(e,t,n){"use strict";var r,o=n(16),i=n.n(o);t.a=function(){if(void 0!==r)return r;var e=visualViewport.scale,t=document.createElement("div");t.style.cssText="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: -9996; display: block;",document.body.insertBefore(t,document.body.firstChild);var n=t.getBoundingClientRect();t.remove();var o=Math.round(n.width*e),c=Math.round(n.height*e);return r=o<c?{width:o,height:c}:{width:c,height:o},i()({},r)}},function(e,t,n){"use strict";n.r(t),t.default=function(){try{return window.screen.width+"/"+window.screen.height}catch(e){}}},function(e,t){function n(){return e.exports=n=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)({}).hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e},e.exports.__esModule=!0,e.exports.default=e.exports,n.apply(null,arguments)}e.exports=n,e.exports.__esModule=!0,e.exports.default=e.exports},function(e,t,n){var r={"./_uaVerRef.js":18,"./audioRef.js":19,"./ch.bitness.js":20,"./ch.browserFullVersionList.js":21,"./ch.browserList.js":22,"./ch.model.js":23,"./ch.platform.js":24,"./ch.platformVersion.js":25,"./connectionType.js":26,"./cookieSupport.js":10,"./css.animations.js":27,"./css.columns.js":28,"./css.transforms.js":29,"./css.transitions.js":30,"./ddg.js":31,"./deviceAspectRatio.js":32,"./devicePixelRatio.js":33,"./displayColorDepth.js":34,"./downlink.js":35,"./effectiveConnectionType.js":36,"./flashCapable.js":37,"./html.audio.js":38,"./html.canvas.js":7,"./html.inlinesvg.js":39,"./html.svg.js":40,"./html.video.ap4x.js":41,"./html.video.av1.js":42,"./html.video.av1016M08.js":43,"./html.video.js":44,"./js.accessDom.js":45,"./js.applicationCache.js":46,"./js.battery.js":47,"./js.deviceMotion.js":48,"./js.deviceOrientation.js":49,"./js.forceTouch.js":50,"./js.geoLocation.js":51,"./js.indexedDB.js":52,"./js.json.js":53,"./js.localStorage.js":13,"./js.modifyCss.js":54,"./js.modifyDom.js":55,"./js.querySelector.js":56,"./js.sessionStorage.js":57,"./js.supportBasicJavaScript.js":58,"./js.supportConsoleLog.js":59,"./js.supportEventListener.js":1,"./js.supportEvents.js":78,"./js.touchEvents.js":60,"./js.webGl.js":61,"./js.webGlRenderer.js":62,"./js.webSockets.js":63,"./js.webSqlDatabase.js":64,"./js.webWorkers.js":65,"./js.xhr.js":66,"./mouseActivity.js":67,"./orientation.js":68,"./platformArchitecture.js":69,"./rendererRef.js":70,"./requestingMobileUx.js":71,"./roundTripTime.js":72,"./saveData.js":73,"./screenWidthHeight.js":15,"./timeZone.js":74,"./usableDisplayHeight.js":75,"./usableDisplayWidth.js":76,"./userMedia.js":77};function o(e){var t=i(e);return n(t)}function i(e){if(!n.o(r,e)){var t=new Error("Cannot find module '"+e+"'");throw t.code="MODULE_NOT_FOUND",t}return r[e]}o.keys=function(){return Object.keys(r)},o.resolve=i,e.exports=o,o.id=17},function(e,t,n){"use strict";n.r(t),t.default=function(e){if(void 0!==e)return e;var t=navigator.userAgent,n=t.indexOf("Version/");if(-1!==n){var r=n+"Version/".length,o=t.indexOf(" ",r),i=t.slice(r,o),c=parseInt(i,10);if(!Number.isNaN(c))return c}}},function(e,t,n){"use strict";n.r(t);var r=n(9);t.default=function(e,t){if(void 0!==e)return t(e);var n=null;try{if(!(n=new(window.OfflineAudioContext||window.webkitOfflineAudioContext)(1,44100,44100)))return t();var o=n.createOscillator();o.type="triangle",o.frequency.value=1e4;var i=n.createDynamicsCompressor();i.threshold&&(i.threshold.value=-50),i.knee&&(i.knee.value=40),i.ratio&&(i.ratio.value=12),i.reduction&&(i.reduction.value=-20),i.attack&&(i.attack.value=0),i.release&&(i.release.value=.25),o.connect(i),i.connect(n.destination),o.start(0),n.startRendering(),n.oncomplete=function(e){for(var n=!1,o=0;o<e.renderedBuffer.length;o++)n=Object(r.a)(e.renderedBuffer.getChannelData(0)[o].toString(),n);n&&t(n),i.disconnect()}}catch(e){t()}}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.bitness"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.browserFullVersionList"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.browserList"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.model"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){n(0).default.then((function(e){t(e["ch.platform"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){t(e["ch.platformVersion"])}))}},function(e,t,n){"use strict";n.r(t),t.default=function(){return n(6).default.type}},function(e,t,n){"use strict";n.r(t);var r=n(3);t.default=function(){return Object(r.a)("animationName")}},function(e,t,n){"use strict";n.r(t);var r=n(3);t.default=function(){return Object(r.a)("columnCount")}},function(e,t,n){"use strict";n.r(t);var r=n(11);t.default=function(){return!!Object(r.a)(["transformProperty","WebkitTransform","MozTransform","OTransform","msTransform"])}},function(e,t,n){"use strict";n.r(t);var r=n(3);t.default=function(){return Object(r.a)("transitionProperty")}},function(e,t,n){"use strict";n.r(t),t.default=function(){if(void 0!==navigator.duckduckgo)return{navigator:!0,platform:navigator.duckduckgo.platform}}},function(e,t,n){"use strict";n.r(t);var r=n(12),o=n(15);t.default=function(e){if(void 0!==e)return e;var t=["2/3","40/71","3/4","16/9","16/10","375/667","9/16","10/16","375/812","207/448"],n=Object(o.default)();return n&&t.push(n),Object(r.a)("device-aspect-ratio",t)}},function(e,t,n){"use strict";n.r(t),t.default=function(){var e=1;try{e=window.devicePixelRatio}catch(e){}return e+""}},function(e,t,n){"use strict";n.r(t),t.default=function(){return screen.colorDepth}},function(e,t,n){"use strict";n.r(t),t.default=function(){return n(6).default.downlink}},function(e,t,n){"use strict";n.r(t),t.default=function(){return n(6).default.effectiveType}},function(e,t,n){"use strict";n.r(t),t.default=function(){try{if(navigator.plugins&&navigator.plugins.length>0&&navigator.mimeTypes){var e="application/x-shockwave-flash";if(navigator.mimeTypes[e]&&navigator.mimeTypes[e].enabledPlugin)return!0}if("function"==typeof ActiveXObject||"object"==typeof ActiveXObject){var t=["ShockwaveFlash.ShockwaveFlash.7","ShockwaveFlash.ShockwaveFlash.7","ShockwaveFlash.ShockwaveFlash"];for(var n in t)try{return new ActiveXObject(t[n]),!0}catch(e){}}}catch(e){}return!1}},function(e,t,n){"use strict";n.r(t),t.default=function(e){if(void 0!==e)return e;if(!document.createElement)return!1;var t=document.createElement("audio");try{if(t.canPlayType){var n={};return n.ogg=""!==t.canPlayType('audio/ogg; codecs="vorbis"'),n.mp3=""!==t.canPlayType("audio/mpeg;"),n.wav=""!==t.canPlayType('audio/wav; codecs="1"'),n.m4a=""!==t.canPlayType("audio/x-m4a;"),n.m4a=""!=t.canPlayType("audio/aac;"),n}}catch(e){}return!1}},function(e,t,n){"use strict";n.r(t);t.default=function(e){if(void 0!==e)return e;if(!document.createElement)return!1;var t=document.createElement("div");return t.innerHTML="<svg/>","http://www.w3.org/2000/svg"==(t.firstChild&&t.firstChild.namespaceURI)}},function(e,t,n){"use strict";n.r(t);t.default=function(){return!!document.createElementNS&&!!document.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect}},function(e,t,n){"use strict";n.r(t);var r=n(4);t.default=function(e){return void 0!==e?e:Object(r.a)('video/quicktime; codecs="ap4x"')}},function(e,t,n){"use strict";n.r(t);var r=n(4);t.default=function(e){return void 0!==e?e:Object(r.a)('video/mp4; codecs="av01.0.05M.08"')}},function(e,t,n){"use strict";n.r(t);var r=n(4);t.default=function(e){return void 0!==e?e:Object(r.a)('video/mp4; codecs="av01.0.16M.08"')}},function(e,t,n){"use strict";n.r(t),t.default=function(e){if(void 0!==e)return e;if(!document.createElement)return!1;var t=document.createElement("video");try{if(t.canPlayType){var n={};n.ogg=""!==t.canPlayType('video/ogg; codecs="theora"');var r='video/mp4; codecs="avc1.42E01E';return n.h264=""!==t.canPlayType(r+'"')||""!==t.canPlayType(r+', mp4a.40.2"'),n.webm=""!==t.canPlayType('video/webm; codecs="vp8, vorbis"'),n}}catch(e){}return!1}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!document.getElementById&&!!document.getElementsByTagName&&!!document.getElementsByName}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.applicationCache}},function(e,t,n){"use strict";n.r(t),t.default=function(){var e=navigator.battery||navigator.webkitBattery||navigator.mozBattery;if(e)return e}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.DeviceMotionEvent}},function(e,t,n){"use strict";n.r(t);var r=n(1);t.default=function(e,t){if(void 0!==e)return t(e);if(!Object(r.default)())return t(!1);var n=function(e){null!=e&&null!=e.alpha?t(!0):null==e&&t(!1),window.removeEventListener("deviceorientation",n,{once:!0,capture:!0})};window.addEventListener("deviceorientation",n,{once:!0,capture:!0})}},function(e,t,n){"use strict";n.r(t);var r=n(1);t.default=function(e,t){if(void 0!==e)return t(e);if(!Object(r.default)())return t(!1);var n=!1,o=function(e){switch(e.type){case"touchforcechange":try{var r=e.touches[0];"direct"==r.touchType&&r.force>=.01&&(n=!0,t(!0)),window.removeEventListener("touchforcechange",o,!1)}catch(e){}break;case"touchend":n||t(!1);try{window.removeEventListener("touchend",o,!1)}catch(e){}}};window.addEventListener("touchforcechange",o,{once:!0,capture:!0}),window.addEventListener("touchend",o,{once:!0,capture:!0})}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!navigator.geolocation}},function(e,t,n){"use strict";n.r(t);var r=n(5);t.default=function(){return Object(r.a)(window,"indexedDB")}},function(e,t,n){"use strict";n.r(t),t.default=function(){return"object"==typeof JSON&&"function"==typeof JSON.stringify}},function(e,t,n){"use strict";n.r(t),t.default=function(){if(!document.createElement)return!1;var e=document.createElement("div");return"object"==typeof e.style&&void 0!==e.style.display&&(e.style.display="none","none"==e.style.display)}},function(e,t,n){"use strict";n.r(t),t.default=function(){if(!document.createElement||!document.appendChild)return!1;var e=document.createElement("span"),t=document.createElement("div");return t.appendChild(e),t==e.parentNode}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!document.querySelector}},function(e,t,n){"use strict";n.r(t),t.default=function(){try{return!!sessionStorage.getItem}catch(e){return!1}}},function(e,t,n){"use strict";n.r(t),t.default=function(){return"function"==typeof alert&&"function"==typeof confirm&&"function"==typeof setTimeout&&"function"==typeof setInterval&&(!!document.location&&!!document.forms)}},function(e,t,n){"use strict";n.r(t),t.default=function(){return"object"==typeof console&&"function"==typeof console.log}},function(e,t,n){"use strict";n.r(t),t.default=function(){return"ontouchstart"in window||navigator&&navigator.pointerEnabled&&navigator.msMaxTouchPoints>1}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.WebGLRenderingContext}},function(e,t,n){"use strict";n.r(t);var r=n(7);t.default=function(e){if(void 0!==e)return e;if(Object(r.default)()){var t=document.createElement("canvas"),n=t.getContext("webgl")||t.getContext("experimental-webgl");if(n){var o=n.getExtension("WEBGL_debug_renderer_info");if(o){var i=n.getParameter(o.UNMASKED_RENDERER_WEBGL);if(i)return i}}}}},function(e,t,n){"use strict";n.r(t);var r=n(5);t.default=function(){return Object(r.a)(window,"WebSocket")}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.openDatabase}},function(e,t,n){"use strict";n.r(t),t.default=function(){return!!window.Worker}},function(e,t,n){"use strict";n.r(t),t.default=function(){return"function"==typeof XMLHttpRequest||"object"==typeof XMLHttpRequest}},function(e,t,n){"use strict";n.r(t);var r=n(1);t.default=function(e,t){if(void 0!==e)return t(e);if(!Object(r.default)())return t(!1);var n=function(){t(!0);try{window.removeEventListener("mousemove",n,!1)}catch(e){}};window.addEventListener("mousemove",n,{once:!0,capture:!0})}},function(e,t,n){"use strict";n.r(t),t.default=function(){return window.orientation}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){var n=e.platformArchitecture;t(n)}))}},function(e,t,n){"use strict";n.r(t);var r=n(7),o=n(12),i=n(9);t.default=function(e){if(void 0!==e)return e;if(Object(r.default)()){var t=document.createElement("canvas"),n=t.getContext("2d"),c="DeviceAtlas";return n.textBaseline="top",n.font="16px 'Arial'",n.textBaseline="alphabetic",n.rotate(.05),n.fillStyle="#f60",n.fillRect(125,1,62,20),n.fillStyle="#069",n.fillText(c,2,15),n.fillStyle="rgba(102, 200, 0, 0.7)",n.fillText(c,4,17),n.shadowBlur=10,n.shadowColor="blue",n.rotate(-.15),n.fillRect(-20,25,234,5),("p3"===Object(o.a)("color-gamut",["p3"])?"1":"0")+Object(i.a)(t.toDataURL())}}},function(e,t,n){"use strict";n.r(t),t.default=function(e,t){if(void 0!==e)return t(e);n(0).default.then((function(e){var n=e.requestingMobileUx;t(n)}))}},function(e,t,n){"use strict";n.r(t),t.default=function(){return n(6).default.rtt}},function(e,t,n){"use strict";n.r(t),t.default=function(){return n(6).default.saveData}},function(e,t,n){"use strict";n.r(t),t.default=function(){var e;if("undefined"!=typeof Intl)return null==(e=Intl.DateTimeFormat())||null==(e=e.resolvedOptions())?void 0:e.timeZone}},function(e,t,n){"use strict";n.r(t);var r=n(14);t.default=function(e){return void 0!==e?e:Object(r.a)().height}},function(e,t,n){"use strict";n.r(t);var r=n(14);t.default=function(e){return void 0!==e?e:Object(r.a)().width}},function(e,t,n){"use strict";n.r(t);var r=n(5);t.default=function(){return Object(r.a)(navigator,"getUserMedia")}},function(e,t,n){"use strict";n.r(t);var r=function(e,t){if(!document.createElement)return!1;var n=document.createElement(t),r=(e="on"+e)in n;return r||(n.setAttribute||(n=document.createElement("div")),n.setAttribute&&n.removeAttribute&&(n.setAttribute(e,""),r="function"==typeof n[e])),r};t.default=function(){var e={submit:"form",click:"input",change:"input",load:"img",select:"input"};for(var t in e)if(!r(t,e[t]))return!1;return!0}}]).default;
    /* jshint ignore:end */
    // Library is now loaded after this point as the DA library will look for window.DeviceAtlasCollector.

    _DeviceAtlasCollector = DeviceAtlasCollector; // this will be there after the lib is imported by grunt.

    return _DeviceAtlasCollector;
  }

  return getApiClient().init();
})({
  window: window,
  document: document,
  navigator: navigator
});


/***/ }),

/***/ 922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* jshint strict: false */

/* unused reexport */ __webpack_require__(914);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(922);
/******/ 	
/******/ })()
;